/* eslint-disable no-continue */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
import DashboardLayout from "pages/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/Navbars/DashboardNavbar";
import React, { useState, useCallback, useEffect, useMemo, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useScreenContext } from "context/ScreenContext";
import INDataTable from "components/INDataTable";
import useFetchWithMsal from "hooks/useFetchWithMsal";
import { protectedResources, siteData } from "authConfig";
import {
  Alert,
  Autocomplete,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Tooltip as MuiTooltip,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useCurrentUser } from "context/UserContext";
// V2 dashboard panel — replaces ONLY the Dashboard tab content when tenant.modules.horizonV2 is on.
import AnticipateHorizonScanV2 from "pages/Anticipate/AnticipateHorizonScanV2";
import AnticipateEmergingThemesV2 from "pages/Anticipate/AnticipateEmergingThemesV2";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import BlockIcon from "@mui/icons-material/Block";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ComposedChart,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import useThemeChanges from "pages/Anticipate/useThemeChanges";
import SearchParametersPanel from "./SearchParametersPanel";

// ── "What's changed since last visit" UI helpers ────────────────────────────
// Toggle button (matches the style used on the home Anticipate Dashboard).
function ChangeToggle({ on, onClick, summary }) {
  const parts = [];
  if (summary) {
    if (summary.new) parts.push(`${summary.new} new`);
    if (summary.rerated) parts.push(`${summary.rerated} re-rated`);
    if (summary.volume) parts.push(`${summary.volume} volume`);
    if (summary.trend) parts.push(`${summary.trend} trend flip`);
  }
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
      <Box
        onClick={onClick}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          px: 1.25,
          py: 0.5,
          borderRadius: "6px",
          border: "1px solid",
          borderColor: on ? "#f97316" : "rgba(0,0,0,0.2)",
          bgcolor: on ? "#fff7ed" : "transparent",
          cursor: "pointer",
          fontSize: "0.72rem",
          fontWeight: 600,
          color: on ? "#c2410c" : "#666",
          whiteSpace: "nowrap",
        }}
      >
        {on ? "● Showing changes" : "○ Show what's changed"}
      </Box>
      {on && (
        <MDTypography variant="caption" sx={{ color: "#9a3412", fontSize: "0.7rem" }}>
          {parts.length
            ? `${parts.join(" · ")} since your last visit`
            : "No changes since your last visit"}
        </MDTypography>
      )}
    </Box>
  );
}

// Inline change chips for a single theme. `change` is the object returned by changeFor().
function ChangeMarkers({ change, size = "sm" }) {
  if (!change) return null;
  const fs = size === "sm" ? "0.55rem" : "0.62rem";
  const chip = (label, bg, color, key) => (
    <Box
      key={key}
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: "5px",
        py: "1px",
        borderRadius: "4px",
        fontSize: fs,
        fontWeight: 700,
        bgcolor: bg,
        color,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </Box>
  );
  const chips = [];
  if (change.isNew) chips.push(chip("NEW", "#ede7f6", "#52009b", "new"));
  if (change.ratingChanged)
    chips.push(chip(`was ${change.ratingChanged.from}`, "#fff3e0", "#e65100", "rate"));
  if (change.volumeChanged)
    chips.push(
      chip(
        `${change.volumeChanged.diff > 0 ? "▲" : "▼"} vol`,
        change.volumeChanged.diff > 0 ? "#ffebee" : "#e8f5e9",
        change.volumeChanged.diff > 0 ? "#b71c1c" : "#1b5e20",
        "vol"
      )
    );
  if (change.trendFlipped)
    chips.push(
      chip(
        change.trendFlipped.to === "increasing" ? "↗ trend flip" : "↘ trend flip",
        "#e3f2fd",
        "#0d47a1",
        "trend"
      )
    );
  return (
    <Box component="span" sx={{ display: "inline-flex", gap: 0.5, flexWrap: "wrap" }}>
      {chips}
    </Box>
  );
}

function horizonSourceKindBadgeLabel(sourceKind) {
  if (sourceKind === "manual_pdf") return "Manual PDF";
  if (sourceKind === "manual_url") return "Manual link";
  if (sourceKind === "gdelt") return "GDELT";
  if (sourceKind === "bing_news") return "Bing News";
  if (sourceKind === "gnews") return "GNews";
  return String(sourceKind || "");
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function formatHorizonDate(date) {
  if (date == null) return "";
  const s = String(date);
  if (s.length >= 8 && /^\d{8}/.test(s)) {
    const ye = s.substring(0, 4);
    const mo = s.substring(4, 6);
    const da = s.substring(6, 8);
    return `${da}-${mo}-${ye}`;
  }
  try {
    const d = new Date(s);
    if (!Number.isNaN(d.getTime())) return d.toLocaleDateString();
  } catch (_) {
    /* ignore */
  }
  return s;
}

function priorityBandLabel(band) {
  if (band === "high") return "High";
  if (band === "low") return "Low";
  return "Medium";
}

function priorityBandColor(band) {
  if (band === "high") return { bgcolor: "#ffebee", color: "#b71c1c", borderColor: "#ef9a9a" };
  if (band === "low") return { bgcolor: "#f5f5f5", color: "#424242", borderColor: "#bdbdbd" };
  return { bgcolor: "#f3e5f5", color: "#6a1b9a", borderColor: "#ce93d8" };
}

// Colour the consequence level badge based on the level number embedded in the label.
// e.g. "Level 4" → orange; "Level 6" → dark red.
function consequenceLevelColor(label) {
  const n = parseInt((label || "").match(/\d+/)?.[0] || "0", 10);
  if (n >= 6) return { bgcolor: "#ffebee", color: "#b71c1c", borderColor: "#ef9a9a" };
  if (n >= 5) return { bgcolor: "#fff3e0", color: "#e65100", borderColor: "#ffcc80" };
  if (n >= 4) return { bgcolor: "#fff8e1", color: "#f57f17", borderColor: "#ffe082" };
  if (n >= 3) return { bgcolor: "#e8f5e9", color: "#2e7d32", borderColor: "#a5d6a7" };
  if (n >= 2) return { bgcolor: "#e3f2fd", color: "#1565c0", borderColor: "#90caf9" };
  if (n >= 1) return { bgcolor: "#f5f5f5", color: "#616161", borderColor: "#bdbdbd" };
  return { bgcolor: "#ede7f6", color: "#4527a0", borderColor: "#b39ddb" };
}

// ID146 — MBFC "Factual Reporting" scale on the dashboard.
// rank 6 = Very High … 1 = Very Low; 0/null = Unranked (own band at the very bottom).
const FACTUAL_RANK_META = {
  6: { label: "Very High", color: "#1b5e20", bg: "#c8e6c9", border: "#81c784" },
  5: { label: "High", color: "#2e7d32", bg: "#e8f5e9", border: "#a5d6a7" },
  4: { label: "Mostly Factual", color: "#f57f17", bg: "#fff8e1", border: "#ffe082" },
  3: { label: "Mixed", color: "#e65100", bg: "#fff3e0", border: "#ffcc80" },
  2: { label: "Low", color: "#d84315", bg: "#fbe9e7", border: "#ffab91" },
  1: { label: "Very Low", color: "#b71c1c", bg: "#ffebee", border: "#ef9a9a" },
  0: { label: "Unranked", color: "#616161", bg: "#f5f5f5", border: "#bdbdbd" },
};
// ID129 — shared styling for the dashboard filter controls (clear caption label + readable input).
const FILTER_LABEL_SX = {
  fontSize: "0.62rem",
  fontWeight: 700,
  color: "#52009b",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  lineHeight: 1,
  ml: "2px",
};
const FILTER_INPUT_SX = {
  bgcolor: "#fff",
  "& .MuiInputBase-root": { height: 34 },
  "&.MuiInputBase-root": { height: 34 },
  "& .MuiSelect-select, & input": {
    fontSize: "0.8rem",
    py: 0,
    display: "flex",
    alignItems: "center",
  },
};
const TRUST_Y_LABELS = {
  0: "Unranked",
  1: "Very Low",
  2: "Low",
  3: "Mixed",
  4: "Mostly Factual",
  5: "High",
  6: "Very High",
};
const TRUST_GRIDLINES = [0, 1, 2, 3, 4, 5, 6];
// Y% for a factual rank (0..6): unranked sits in a band below Very Low.
const factualY = (rank) => (rank ? 8 + ((rank - 1) / 5) * 80 : 2);

function sentimentColor(sentiment) {
  if (sentiment === "positive") return "#2e7d32";
  if (sentiment === "negative") return "#d32f2f";
  return "#ed6c02";
}

/** Build table rows from raw article list — used in the theme drill-down view. */
// P2-02 — alert relevance to the company (0-100). Below this, an alert is "off-target" noise and is
// hidden by default (with a Show-all toggle). Unscored alerts (null) are never hidden.
// 50 chosen from the real UAT distribution: a tangential cluster sits at 35-49 (US airports/airlines,
// competitors, other-jurisdiction regulation) with a clean gap at 50-59, so hiding <50 removes ~40%
// noise while keeping every genuinely-relevant item. (60 = stricter still, maps to "likely to affect us".)
const RELEVANCE_HIDE_BELOW = 50;
function relevanceMeta(score) {
  if (score == null || Number.isNaN(Number(score))) return null;
  if (score >= 70) return { bg: "#e7f3ec", color: "#2c7a50", border: "#8fd6a2" };
  if (score >= RELEVANCE_HIDE_BELOW) return { bg: "#fff8e1", color: "#a8690f", border: "#ffe082" };
  return { bg: "#f3f0f5", color: "#6a6478", border: "#d9d2e2" };
}

function mapRawToTableRows(rawList, onIgnoreDomain) {
  return (rawList || []).map((data) => {
    const l1 = (data.primaryL1CategoryName || "").trim();
    const l2 = (data.primaryL2CategoryName || "").trim();
    const categoryPath = l1 && l2 ? `${l1} › ${l2}` : l1 || l2 || "";

    return {
      id: data.id,
      title: (
        <Box sx={{ py: 1, borderBottom: "1px solid rgba(0,0,0,0.06)" }}>
          {/* Title row: title + open-in-new icon + importance badge + date */}
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 1,
              mb: 0.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flex: 1, minWidth: 0 }}>
              <MDTypography
                variant="body2"
                color="info"
                fontWeight="bold"
                sx={{ wordBreak: "break-word" }}
              >
                {data.title}
              </MDTypography>
              {data.link || data.url ? (
                <a
                  href={data.url || data.link}
                  rel="noreferrer"
                  target="_blank"
                  style={{ flexShrink: 0, color: "#1565c0", display: "flex" }}
                >
                  <OpenInNewIcon sx={{ fontSize: 14 }} />
                </a>
              ) : null}
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexShrink: 0 }}>
              {(() => {
                const rm = relevanceMeta(data.relevanceScore);
                if (!rm) return null;
                return (
                  <MuiTooltip
                    title={`Relevance to your business: ${data.relevanceScore}/100${
                      data.relevanceReason ? ` — ${data.relevanceReason}` : ""
                    }`}
                    placement="top"
                  >
                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        px: "6px",
                        py: "2px",
                        borderRadius: "4px",
                        fontSize: "0.65rem",
                        fontWeight: 700,
                        lineHeight: 1.4,
                        border: "1px solid",
                        cursor: "default",
                        bgcolor: rm.bg,
                        color: rm.color,
                        borderColor: rm.border,
                      }}
                    >
                      ◉ {data.relevanceScore}
                    </Box>
                  </MuiTooltip>
                );
              })()}
              {data.consequenceLevelLabel ? (
                <MuiTooltip
                  title={`Consequence: ${data.consequenceTypeLabel || ""}${
                    data.consequenceTypeLabel && data.consequenceLevelLabel ? " — " : ""
                  }${data.consequenceLevelLabel || ""}`}
                  placement="top"
                >
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      px: "6px",
                      py: "2px",
                      borderRadius: "4px",
                      fontSize: "0.65rem",
                      fontWeight: 700,
                      lineHeight: 1.4,
                      border: "1px solid",
                      cursor: "default",
                      ...consequenceLevelColor(data.consequenceLevelLabel),
                    }}
                  >
                    {data.consequenceLevelLabel}
                    {data.consequenceTypeLabel ? ` · ${data.consequenceTypeLabel}` : ""}
                  </Box>
                </MuiTooltip>
              ) : null}
              <MDTypography variant="caption" color="text" sx={{ whiteSpace: "nowrap" }}>
                {formatHorizonDate(data.date)}
              </MDTypography>
              {data.sourceDomain && onIgnoreDomain ? (
                <MuiTooltip title={`Ignore all news from ${data.sourceDomain}`} placement="top">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onIgnoreDomain(data.sourceDomain);
                    }}
                    sx={{ p: "2px", color: "#b71c1c" }}
                    aria-label={`Ignore ${data.sourceDomain}`}
                  >
                    <BlockIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </MuiTooltip>
              ) : null}
            </Box>
          </Box>

          {/* URL */}
          {data.url || data.link ? (
            <MDTypography
              variant="caption"
              sx={{ display: "block", color: "#1565c0", wordBreak: "break-all", mb: 0.5 }}
            >
              <a
                href={data.url || data.link}
                rel="noreferrer"
                target="_blank"
                style={{ color: "inherit" }}
              >
                {data.url || data.link}
              </a>
            </MDTypography>
          ) : null}

          {/* Summary */}
          {data.summary ? (
            <MDTypography variant="body2" color="text" fontWeight="regular" sx={{ mb: 0.5 }}>
              {data.summary}
            </MDTypography>
          ) : null}

          {/* Why it matters */}
          {data.whyItMatters ? (
            <MDTypography
              variant="body2"
              color="text"
              fontWeight="regular"
              sx={{ color: "text.secondary", mb: 0.5 }}
            >
              <strong>Why it matters:</strong> {data.whyItMatters}
            </MDTypography>
          ) : null}

          {/* Category path: L1 › L2 */}
          {categoryPath ? (
            <MDTypography
              variant="caption"
              sx={{ display: "block", color: "#1565c0", fontWeight: 600, mb: 0.5 }}
            >
              {categoryPath}
            </MDTypography>
          ) : null}

          {/* Badges + ignore action */}
          <Box
            sx={{ display: "flex", gap: "6px", flexWrap: "wrap", mt: 0.25, alignItems: "center" }}
          >
            {data.sentiment ? (
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  px: "6px",
                  py: "2px",
                  borderRadius: "4px",
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  lineHeight: 1.4,
                  bgcolor: sentimentColor(data.sentiment),
                  color: "#fff",
                }}
              >
                {data.sentiment}
              </Box>
            ) : null}
            {data.sourceKind ? (
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  px: "6px",
                  py: "2px",
                  borderRadius: "4px",
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  lineHeight: 1.4,
                  bgcolor: "#5d4037",
                  color: "#fff",
                }}
              >
                {horizonSourceKindBadgeLabel(data.sourceKind) || data.sourceKind}
              </Box>
            ) : null}
            {data.sourceDomain ? (
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  px: "6px",
                  py: "2px",
                  borderRadius: "4px",
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  lineHeight: 1.4,
                  bgcolor: "#455a64",
                  color: "#fff",
                }}
              >
                {data.sourceDomain}
              </Box>
            ) : null}
            {(() => {
              // ID146 — per-alert MBFC Factual Reporting badge (very_high…very_low), or "Unranked".
              const meta = data.factualRank != null ? FACTUAL_RANK_META[data.factualRank] : null;
              if (meta) {
                return (
                  <MuiTooltip
                    title={`Source trust (Media Bias / Fact Check): Factual Reporting — ${meta.label}`}
                    placement="top"
                  >
                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        px: "6px",
                        py: "2px",
                        borderRadius: "4px",
                        fontSize: "0.65rem",
                        fontWeight: 700,
                        lineHeight: 1.4,
                        cursor: "default",
                        bgcolor: meta.bg,
                        color: meta.color,
                        border: "1px solid",
                        borderColor: meta.border,
                      }}
                    >
                      {meta.label}
                    </Box>
                  </MuiTooltip>
                );
              }
              return (
                <MuiTooltip
                  title="Source trust: Unranked — not in the Media Bias / Fact Check database"
                  placement="top"
                >
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      px: "6px",
                      py: "2px",
                      borderRadius: "4px",
                      fontSize: "0.65rem",
                      fontWeight: 600,
                      lineHeight: 1.4,
                      cursor: "default",
                      bgcolor: "#f5f5f5",
                      color: "#9e9e9e",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    Unranked
                  </Box>
                </MuiTooltip>
              );
            })()}
            {/* Consequence badge moved to header row — removed duplicate here */}
          </Box>
        </Box>
      ),
    };
  });
}

function horizonDocId(doc) {
  if (!doc) return "";
  if (doc.id != null) return String(doc.id);
  // eslint-disable-next-line no-underscore-dangle -- Mongo/API may expose `_id`
  if (doc._id != null) return String(doc._id);
  return "";
}

function mergeHorizonRawLists(immediateList, aggregateList) {
  const imm = Array.isArray(immediateList) ? immediateList : [];
  const agg = Array.isArray(aggregateList) ? aggregateList : [];
  const seen = new Set();
  const out = [];
  const pushUniqueInOrder = (items) => {
    items.forEach((item) => {
      const id = horizonDocId(item);
      if (id && seen.has(id)) return;
      if (id) seen.add(id);
      out.push(item);
    });
  };
  pushUniqueInOrder(imm);
  pushUniqueInOrder(agg);
  return out;
}

function driverTypeLabel(dt) {
  if (dt === "value_driver") return "Value Driver";
  if (dt === "dependency") return "Dependency";
  if (dt === "threat") return "Threat";
  return dt;
}

function driverTypeColor(dt) {
  if (dt === "value_driver") return "#1565c0";
  if (dt === "dependency") return "#e65100";
  if (dt === "threat") return "#b71c1c";
  return "#455a64";
}

/**
 * Determine the dominant driver type across a theme's relationship tags.
 * Returns "threat" | "value_driver" | "dependency" | "mixed"
 */
function dominantDriverType(relationshipTags) {
  const counts = { threat: 0, value_driver: 0, dependency: 0 };
  (relationshipTags || []).forEach((tag) => {
    (tag.driverTypes || []).forEach((dt) => {
      if (counts[dt] !== undefined) counts[dt] += 1;
    });
  });
  const max = Math.max(counts.threat, counts.value_driver, counts.dependency);
  if (max === 0) return "mixed";
  if (counts.threat === max && counts.threat > counts.value_driver) return "threat";
  if (counts.value_driver === max && counts.value_driver > counts.threat) return "value_driver";
  if (
    counts.dependency === max &&
    counts.dependency > counts.threat &&
    counts.dependency > counts.value_driver
  )
    return "dependency";
  return "mixed";
}

/**
 * Semantic label for trend direction given the theme's dominant driver type.
 * For threats:       up = "Escalating", down = "De-escalating"
 * For value drivers: up = "Strengthening", down = "Weakening"
 * For dependency:    up = "Increasing", down = "Decreasing"
 * For mixed/flat:    just show the delta
 */
function themeTrendBadgeContent(t) {
  const sign = t.trendVsYesterday > 0 ? "+" : "";
  const delta = `${sign}${t.trendVsYesterday}`;
  if (t.trendLabel === "flat") return "→ Stable";
  const dom = dominantDriverType(t.relationshipTags);
  if (t.trendLabel === "up") {
    if (dom === "threat") return `↑ Escalating (${delta})`;
    if (dom === "value_driver") return `↑ Strengthening (${delta})`;
    if (dom === "dependency") return `↑ Increasing (${delta})`;
    return `↑ ${delta} vs yest.`;
  }
  if (t.trendLabel === "down") {
    if (dom === "threat") return `↓ De-escalating (${delta})`;
    if (dom === "value_driver") return `↓ Weakening (${delta})`;
    if (dom === "dependency") return `↓ Decreasing (${delta})`;
    return `↓ ${delta} vs yest.`;
  }
  return "→ Stable";
}

/**
 * Badge colour for trend — semantically correct based on driver type.
 * Threat theme rising = bad (red). Threat theme falling = good (green).
 * Value driver theme rising = good (green). Falling = bad (red).
 * Dependency / mixed = neutral orange for changes.
 */
function themeTrendBadgeColor(t) {
  if (t.trendLabel === "flat") return "#757575";
  const dom = dominantDriverType(t.relationshipTags);
  if (dom === "threat") {
    return t.trendLabel === "up" ? "#d32f2f" : "#2e7d32";
  }
  if (dom === "value_driver") {
    return t.trendLabel === "up" ? "#2e7d32" : "#d32f2f";
  }
  // dependency or mixed — directional but neutral in meaning
  return "#e65100";
}

function HorizonThemeOverviewRows({
  themes,
  loading,
  error,
  adminView,
  onSelectTheme,
  themeCategories,
  selectedThemes,
  onToggleTheme,
  isHistorical,
  canMonitor,
  linkedThemeKeySet,
  linkedRiskFor,
  onOpenWatchlistRisk,
  sortOrder,
  onSortChange,
  showChange,
  changeFor,
}) {
  // Client-side pagination — show 20 themes per page (the overview returns the full list).
  const PER_PAGE = 20;
  const [page, setPage] = useState(0);
  // Reset to the first page whenever the (filtered/sorted) theme list changes.
  useEffect(() => {
    setPage(0);
  }, [themes]);
  const pageThemes = (themes || []).slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress sx={{ color: "#52009b" }} />
      </Box>
    );
  }
  if (error) {
    return (
      <Alert severity="warning" sx={{ mb: 2 }}>
        {error}
      </Alert>
    );
  }
  if (!themes || themes.length === 0) {
    return (
      <MDTypography variant="body2" color="text" sx={{ mb: 2 }}>
        No themes match the current filters. After news ingest assigns theme tags, themes will
        appear here.
      </MDTypography>
    );
  }
  return (
    <Box
      sx={{
        mb: 2,
        border: "1px solid rgba(82,0,155,0.18)",
        borderRadius: 1,
        overflow: "hidden",
        bgcolor: "background.paper",
      }}
    >
      <Box
        sx={{
          display: { xs: "none", sm: "flex" },
          px: 2,
          py: 1,
          gap: 2,
          alignItems: "center",
          bgcolor: "rgba(82,0,155,0.06)",
          borderBottom: "1px solid rgba(82,0,155,0.15)",
        }}
      >
        {/* Clickable column headers for sorting */}
        <Box
          onClick={() => onSortChange && onSortChange("name_asc")}
          sx={{
            flex: "1 1 40%",
            minWidth: 0,
            cursor: onSortChange ? "pointer" : "default",
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <MDTypography variant="caption" fontWeight="bold" color="text">
            Theme
          </MDTypography>
          {sortOrder === "name_asc" && (
            <MDTypography variant="caption" color="text">
              ↑
            </MDTypography>
          )}
        </Box>
        <Box
          onClick={() => onSortChange && onSortChange("risk_level")}
          sx={{
            flex: "0 0 auto",
            cursor: onSortChange ? "pointer" : "default",
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <MDTypography variant="caption" fontWeight="bold" color="text">
            Risk level
          </MDTypography>
          {sortOrder === "risk_level" && (
            <MDTypography variant="caption" color="text">
              ↑
            </MDTypography>
          )}
        </Box>
        <Box
          onClick={() =>
            onSortChange && onSortChange(sortOrder === "date_desc" ? "date_asc" : "date_desc")
          }
          sx={{
            flex: "0 0 auto",
            cursor: onSortChange ? "pointer" : "default",
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <MDTypography variant="caption" fontWeight="bold" color="text">
            Today / trend
          </MDTypography>
          {(sortOrder === "date_desc" || sortOrder === "date_asc") && (
            <MDTypography variant="caption" color="text">
              {sortOrder === "date_desc" ? "↓" : "↑"}
            </MDTypography>
          )}
        </Box>
        {/* ID62 — sortable Trend column (worsening → stable → improving). */}
        <Box
          onClick={() => onSortChange && onSortChange("trend")}
          sx={{
            flex: "0 0 auto",
            cursor: onSortChange ? "pointer" : "default",
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <MDTypography variant="caption" fontWeight="bold" color="text">
            Trend
          </MDTypography>
          {sortOrder === "trend" && (
            <MDTypography variant="caption" color="text">
              ↑
            </MDTypography>
          )}
        </Box>
        <MDTypography
          variant="caption"
          fontWeight="bold"
          color="text"
          sx={{ width: 168, flexShrink: 0, textAlign: "right" }}
        >
          14-day volume
        </MDTypography>
      </Box>
      {pageThemes.map((t) => {
        const isChecked = selectedThemes ? selectedThemes.has(t.themeKey) : false;
        return (
          <Box
            key={t.themeKey}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "stretch", sm: "center" },
              gap: { xs: 1.5, sm: 2 },
              px: 1,
              py: 1.5,
              borderBottom: "1px solid rgba(82,0,155,0.1)",
              borderLeft: `3px solid ${isChecked ? "#52009b" : "transparent"}`,
              bgcolor: isChecked ? "rgba(82,0,155,0.04)" : "transparent",
              "&:last-of-type": { borderBottom: "none" },
              "&:hover": {
                bgcolor: "rgba(82,0,155,0.04)",
                borderLeftColor: "#52009b",
              },
            }}
          >
            {/* Checkbox for risk monitoring selection */}
            {canMonitor && (
              <Checkbox
                size="small"
                checked={isChecked}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => {
                  e.stopPropagation();
                  if (onToggleTheme) onToggleTheme(t.themeKey, t);
                }}
                sx={{
                  flexShrink: 0,
                  alignSelf: "flex-start",
                  mt: "2px",
                  color: "#52009b",
                  "&.Mui-checked": { color: "#52009b" },
                }}
              />
            )}
            {/* Clickable area → drill into theme */}
            <Box
              role={isHistorical ? undefined : "button"}
              tabIndex={isHistorical ? undefined : 0}
              onKeyDown={(e) => {
                if (isHistorical) return;
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onSelectTheme(t.themeKey);
                }
              }}
              onClick={() => {
                if (!isHistorical) onSelectTheme(t.themeKey);
              }}
              sx={{
                display: "flex",
                flex: 1,
                gap: { xs: 1.5, sm: 2 },
                alignItems: "center",
                flexDirection: { xs: "column", sm: "row" },
                cursor: isHistorical ? "default" : "pointer",
                minWidth: 0,
                opacity: isHistorical ? 0.75 : 1,
              }}
            >
              <Box sx={{ flex: "1 1 45%", minWidth: 0 }}>
                {/* Theme label + matrix rating badge + watchlist flag */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.75,
                    flexWrap: "wrap",
                    mb: 0.25,
                  }}
                >
                  <MDTypography variant="subtitle1" color="info" fontWeight="bold">
                    {t.llmTrend?.displayName || t.themeLabel}
                  </MDTypography>
                  {t.llmTrend?.displayName && t.llmTrend.displayName !== t.themeLabel && (
                    <MDTypography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontStyle: "italic" }}
                    >
                      {t.themeLabel}
                    </MDTypography>
                  )}
                  {t.llmTrend?.matrixRating && (
                    <MuiTooltip
                      title={[
                        `Risk level: ${t.llmTrend.matrixRating}${
                          t.llmTrend.matrixRating === "E"
                            ? " — Extreme"
                            : t.llmTrend.matrixRating === "H"
                            ? " — High"
                            : t.llmTrend.matrixRating === "M"
                            ? " — Medium"
                            : t.llmTrend.matrixRating === "L"
                            ? " — Low"
                            : " — Very Low"
                        }`,
                        t.llmTrend.consequenceTypeLabel
                          ? `Consequence type: ${t.llmTrend.consequenceTypeLabel}`
                          : "",
                        t.llmTrend.consequenceLevelLabel
                          ? `Consequence level: ${t.llmTrend.consequenceLevelLabel}`
                          : "",
                        t.llmTrend.plausibilityRating
                          ? `Plausibility: ${t.llmTrend.plausibilityRating}`
                          : "",
                      ]
                        .filter(Boolean)
                        .join(" · ")}
                      placement="top"
                    >
                      <span>
                        <RatingBadge rating={t.llmTrend.matrixRating} size="small" />
                      </span>
                    </MuiTooltip>
                  )}
                  <OriginBadge origin={t.llmTrend?.origin} />
                  {linkedThemeKeySet?.has(t.themeKey) &&
                    (() => {
                      const lr = linkedRiskFor ? linkedRiskFor(t) : null;
                      return (
                        <MuiTooltip
                          title={
                            lr
                              ? `Open linked watchlist risk: ${lr.title}`
                              : "This theme is linked to a watchlist risk"
                          }
                          placement="top"
                        >
                          <Box
                            onClick={(e) => {
                              if (!lr?.id) return;
                              e.stopPropagation(); // don't also trigger the row's select
                              onOpenWatchlistRisk?.(lr.id);
                            }}
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              px: "5px",
                              py: "1px",
                              borderRadius: "4px",
                              fontSize: "0.62rem",
                              fontWeight: 700,
                              bgcolor: "#ede7f6",
                              color: "#52009b",
                              border: "1px solid #ce93d8",
                              flexShrink: 0,
                              cursor: lr?.id ? "pointer" : "default",
                              "&:hover": lr?.id ? { bgcolor: "#e1d4f5" } : undefined,
                            }}
                          >
                            ⚑ Watchlist
                          </Box>
                        </MuiTooltip>
                      );
                    })()}
                  {showChange && changeFor && <ChangeMarkers change={changeFor(t)} size="md" />}
                </Box>
                {/* Single best-fit L2 category */}
                {(() => {
                  const cats = themeCategories ? themeCategories[t.themeKey] : null;
                  // Event-tagged themes: show bestFitL2 directly
                  if (t.bestFitL2 || cats?.bestFitL2) {
                    const l2 = t.bestFitL2 || cats.bestFitL2;
                    return (
                      <MDTypography
                        variant="caption"
                        sx={{ color: "#1565c0", fontWeight: 600, display: "block", mb: 0.5 }}
                      >
                        {l2}
                      </MDTypography>
                    );
                  }
                  if (!cats || cats.l1Names.length === 0) {
                    // ID137 — top-down themes have no alerts; fall back to the AI-assigned category.
                    const metaCat = t.llmTrend?.l2CategoryName || t.llmTrend?.l1CategoryName || "";
                    if (!metaCat) return null;
                    return (
                      <MDTypography
                        variant="caption"
                        sx={{ color: "#1565c0", fontWeight: 600, display: "block", mb: 0.5 }}
                      >
                        {metaCat}
                      </MDTypography>
                    );
                  }
                  const l1 = cats.l1Names[0];
                  const l2 = (cats.l2ByL1[l1] || [])[0];
                  const label = l2 ? `${l2}` : l1;
                  return (
                    <MDTypography
                      variant="caption"
                      sx={{ color: "#1565c0", fontWeight: 600, display: "block", mb: 0.5 }}
                    >
                      {label}
                    </MDTypography>
                  );
                })()}
                {(t.whyItMatters || t.summary) && (
                  <MDTypography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      mb: 0.5,
                    }}
                  >
                    <Box component="span" sx={{ fontWeight: 600, color: "text.primary" }}>
                      Why it matters:{" "}
                    </Box>
                    {t.whyItMatters || t.summary}
                  </MDTypography>
                )}
                {/* Event sub-topic (eventTag) chips intentionally hidden from the theme list. */}
                {/* Search-parameter / relationship-tag chips removed from the Emerging Themes list. */}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  alignItems: "flex-start",
                  flex: { sm: "0 0 auto" },
                  minWidth: 130,
                }}
              >
                {/* ID62 — risk-level trend as a mini line chart (ID54 line), text label fallback. */}
                <ThemeTrendCell theme={t} />
                {/* Matrix rating badge moved to heading row — removed duplicate here */}
                {(() => {
                  if (!adminView) return null; // source-trust % is debug provenance — admins only
                  const rs = t.reliabilitySummary;
                  if (!rs || (rs.dominantTier == null && !rs.unrankedCount)) return null;
                  const meta = FACTUAL_RANK_META[rs.dominantTier != null ? rs.dominantTier : 0];
                  const pct = rs.trustPct;
                  const dist =
                    rs.total > 0
                      ? Object.entries(rs.distribution)
                          .filter(([k, v]) => v > 0 && k !== "unrated" && k !== "null")
                          .sort((a, b) => Number(b[0]) - Number(a[0]))
                          .map(([k, v]) => `${FACTUAL_RANK_META[k]?.label || k}: ${v}`)
                          .join(", ")
                      : "";
                  return (
                    <MuiTooltip
                      title={`Source trust: ${meta.label}${
                        pct != null ? ` · ${pct}% trustworthy` : ""
                      }${dist ? ` — ${dist}` : ""}${
                        rs.unrankedCount ? ` · Unranked: ${rs.unrankedCount}` : ""
                      }`}
                      placement="top"
                    >
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          px: "6px",
                          py: "1px",
                          borderRadius: "4px",
                          fontSize: "0.65rem",
                          fontWeight: 700,
                          lineHeight: 1.5,
                          cursor: "default",
                          bgcolor: meta.bg,
                          color: meta.color,
                          border: "1px solid",
                          borderColor: meta.border,
                        }}
                      >
                        {pct != null ? `${pct}% trust` : meta.label}
                      </Box>
                    </MuiTooltip>
                  );
                })()}
              </Box>
              <Box
                sx={{
                  width: { xs: "100%", sm: 168 },
                  height: 52,
                  flexShrink: 0,
                  alignSelf: { xs: "stretch", sm: "center" },
                }}
              >
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={t.sparkline} margin={{ top: 4, right: 2, left: 0, bottom: 0 }}>
                    <XAxis dataKey="day" hide />
                    <Tooltip
                      labelFormatter={(d) => d}
                      formatter={(v) => [`${v} alerts`, "Count"]}
                    />
                    <Bar dataKey="count" fill="#52009b" radius={[2, 2, 0, 0]} maxBarSize={10} />
                  </BarChart>
                </ResponsiveContainer>
              </Box>
            </Box>
            {/* end clickable area */}
          </Box>
        );
      })}
      {themes.length > PER_PAGE && (
        <TablePagination
          component="div"
          count={themes.length}
          page={page}
          onPageChange={(e, p) => setPage(p)}
          rowsPerPage={PER_PAGE}
          rowsPerPageOptions={[PER_PAGE]}
          sx={{ borderTop: "1px solid rgba(82,0,155,0.15)" }}
        />
      )}
    </Box>
  );
}

HorizonThemeOverviewRows.propTypes = {
  themes: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  error: PropTypes.string,
  adminView: PropTypes.bool,
  onSelectTheme: PropTypes.func.isRequired,
  themeCategories: PropTypes.object,
  selectedThemes: PropTypes.instanceOf(Set),
  onToggleTheme: PropTypes.func,
  isHistorical: PropTypes.bool,
  canMonitor: PropTypes.bool,
  linkedRiskFor: PropTypes.func,
  onOpenWatchlistRisk: PropTypes.func,
};

function SummaryCard({ title, value, subtitle }) {
  return (
    <Grid item xs={12} sm={6} md={3}>
      <Card variant="outlined" sx={{ height: "100%", borderColor: "rgba(82,0,155,0.35)" }}>
        <CardContent>
          <MDTypography
            variant="button"
            color="text"
            fontWeight="regular"
            textTransform="uppercase"
          >
            {title}
          </MDTypography>
          <MDTypography variant="h4" fontWeight="bold" color="info" sx={{ mt: 0.5 }}>
            {value}
          </MDTypography>
          {subtitle ? (
            <MDTypography variant="caption" color="text">
              {subtitle}
            </MDTypography>
          ) : null}
        </CardContent>
      </Card>
    </Grid>
  );
}
SummaryCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subtitle: PropTypes.string,
};

const RATING_ORDER = ["E", "H", "M", "L", "VL"];
const RATING_CONFIG = {
  E: { label: "Extreme", color: "#c62828", bg: "#ffebee", border: "#ef9a9a", textOnDark: true },
  H: { label: "High", color: "#ef6c00", bg: "#fff3e0", border: "#ffcc80", textOnDark: true },
  M: { label: "Medium", color: "#f9a825", bg: "#fff8e1", border: "#ffe082", textOnDark: false },
  L: { label: "Low", color: "#388e3c", bg: "#e8f5e9", border: "#a5d6a7", textOnDark: true },
  VL: { label: "Very Low", color: "#1b5e20", bg: "#c8e6c9", border: "#81c784", textOnDark: true },
};

// Risk level trend chart constants (module-scope so they can be used in a stable dot renderer)
const RISK_LEVEL_NUM_COLOR = {
  5: "#c62828",
  4: "#ef6c00",
  3: "#f9a825",
  2: "#388e3c",
  1: "#1b5e20",
};

// ID54 — colour by the residual letter band (matches the prioritisation matrix).
const RISK_LEVEL_LETTER_COLOR = {
  E: "#c62828",
  H: "#ef6c00",
  M: "#f9a825",
  L: "#388e3c",
  VL: "#1b5e20",
};

function RiskLevelDot({ cx, cy, payload }) {
  if (cx == null || cy == null) return null;
  const color =
    RISK_LEVEL_LETTER_COLOR[payload?.letter] ||
    RISK_LEVEL_NUM_COLOR[payload?.riskLevel] ||
    "#52009b";
  // A hollow dot marks a 5-level fallback day (no granular score recorded yet).
  const exact = payload?.exact !== false;
  return (
    <circle
      cx={cx}
      cy={cy}
      r={5}
      fill={exact ? color : "#fff"}
      stroke={color}
      strokeWidth={exact ? 1.5 : 2}
    />
  );
}

// ID62 — per-theme risk-level trend for the Themes list: a mini line chart (the ID54 risk-level
// line, last 14 days) when there's enough history, otherwise the Worsening/Stable/Improving label.
const TREND_DIR = {
  worsening: { color: "#b71c1c", bg: "#ffebee", border: "#ef9a9a", label: "⚠ Worsening" },
  improving: { color: "#1b5e20", bg: "#e8f5e9", border: "#a5d6a7", label: "✓ Improving" },
  stable: { color: "#37474f", bg: "#eceff1", border: "#b0bec5", label: "~ Stable" },
};
function ThemeTrendCell({ theme }) {
  const lt = theme.llmTrend;
  if (!lt) return null;
  const d = TREND_DIR[lt.direction] || TREND_DIR.stable;
  const tip = lt.narrative
    ? `${d.label.replace(/^[⚠✓~]\s/, "")} — ${lt.narrative} (confidence: ${lt.confidence || "?"})`
    : `Risk-level trend: ${d.label.replace(/^[⚠✓~]\s/, "")}`;
  const spark = Array.isArray(theme.riskLevelSpark) ? theme.riskLevelSpark : [];
  if (spark.length >= 4) {
    return (
      <MuiTooltip title={tip} placement="top">
        <Box
          sx={{
            width: 92,
            height: 26,
            display: "inline-flex",
            alignItems: "center",
            cursor: "default",
          }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={spark} margin={{ top: 3, right: 2, left: 2, bottom: 0 }}>
              <YAxis domain={[0, "dataMax"]} hide />
              <Line
                type="monotone"
                dataKey="riskLevel"
                stroke={d.color}
                strokeWidth={2}
                dot={false}
                isAnimationActive={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </MuiTooltip>
    );
  }
  // Fallback for sparse history — keep the original text label.
  return (
    <MuiTooltip title={tip} placement="top">
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          px: "6px",
          py: "1px",
          borderRadius: "4px",
          fontSize: "0.65rem",
          fontWeight: 700,
          lineHeight: 1.5,
          color: d.color,
          bgcolor: d.bg,
          border: "1px solid",
          borderColor: d.border,
          cursor: "default",
          gap: "3px",
        }}
      >
        {d.label}
      </Box>
    </MuiTooltip>
  );
}
ThemeTrendCell.propTypes = { theme: PropTypes.object };
ThemeTrendCell.defaultProps = { theme: {} };

function RatingBadge({ rating, size = "small" }) {
  const cfg = RATING_CONFIG[rating];
  if (!cfg) return null;
  const px = size === "large" ? "12px" : "7px";
  const py = size === "large" ? "5px" : "2px";
  const fs = size === "large" ? "0.85rem" : "0.65rem";
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px,
        py,
        borderRadius: "5px",
        fontSize: fs,
        fontWeight: 800,
        letterSpacing: "0.05em",
        bgcolor: cfg.color,
        color: "#fff",
        flexShrink: 0,
      }}
    >
      {rating}
    </Box>
  );
}

// ID137 — marks a theme that came from the AI top-down (CRO-to-Board) perspective.
// origin: 'top_down' = no news yet, 'merged' = top-down risk that also has news coverage.
function OriginBadge({ origin, size = "small" }) {
  if (origin !== "top_down" && origin !== "merged") return null;
  const label = origin === "merged" ? "Top-down + News" : "Top-down";
  const fs = size === "large" ? "0.7rem" : "0.55rem";
  return (
    <MuiTooltip
      title={
        origin === "merged"
          ? "AI top-down (CRO) emerging risk that also has live news coverage"
          : "AI top-down (CRO) emerging risk — no news coverage yet"
      }
      placement="top"
    >
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "2px",
          px: "5px",
          py: "1px",
          borderRadius: "4px",
          fontSize: fs,
          fontWeight: 700,
          lineHeight: 1.5,
          cursor: "default",
          bgcolor: origin === "merged" ? "#e0f2f1" : "#ede7f6",
          color: origin === "merged" ? "#00695c" : "#5e35b1",
          border: `1px solid ${origin === "merged" ? "#80cbc4" : "#b39ddb"}`,
        }}
      >
        🧭 {label}
      </Box>
    </MuiTooltip>
  );
}
OriginBadge.propTypes = {
  origin: PropTypes.string,
  size: PropTypes.string,
};

// ── HorizonScatterDashboard ─────────────────────────────────────────────────
// X-axis runs low → high: VL on the left, E on the right.
// Values are the centres of the five equal axis columns so each card sits in its column.
const SCATTER_RATING_X = { VL: 10, L: 30, M: 50, H: 70, E: 90 };
const SCATTER_RATING_COLOR = {
  E: "#c62828",
  H: "#ef6c00",
  M: "#f9a825",
  L: "#388e3c",
  VL: "#1b5e20",
};
const SCATTER_RATING_BG = { E: "#ffebee", H: "#fff3e0", M: "#fff8e1", L: "#e8f5e9", VL: "#c8e6c9" };
const SCATTER_Y_GRIDLINES = [1, 5, 10, 25, 50, 100, 250, 500, 1000];

// Stable per-theme pseudo-random offset (-0.5..0.5) so themes that share the same
// rating/tier don't land on the exact same point — lets them spread apart on zoom.
function themeJitter(key, salt) {
  const s = `${key}|${salt}`;
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) % 1000000007;
  return (Math.abs(h) % 1000) / 1000 - 0.5; // -0.5 .. 0.5
}

function scatterLogY(count, maxCount) {
  // Scale so the highest-volume theme reaches near the top of the plot (no dead space).
  const safeMax = Math.max(maxCount || 1, 2);
  const frac = Math.log10(Math.max(count || 1, 1)) / Math.log10(safeMax);
  return Math.min(86, frac * 80 + 4);
}

function ScatterThemeCard({
  theme,
  isHovered,
  isSelected,
  onClick,
  onMouseEnter,
  onMouseLeave,
  xPct,
  yPct,
  change,
  yMode,
}) {
  const rating = theme.llmTrend?.matrixRating;
  const color = SCATTER_RATING_COLOR[rating] || "#90a4ae";
  const bg = SCATTER_RATING_BG[rating] || "#f5f5f5";
  const active = isHovered || isSelected;
  const trend = theme.trend7d?.direction;
  const changed = !!change;
  // ID146 — Trustworthiness % from MBFC Factual Reporting (avg factual rank / 6, computed server-side).
  const trustPct = theme.reliabilitySummary?.trustPct ?? null;
  const trustColor =
    trustPct == null
      ? "#616161"
      : trustPct >= 67
      ? "#1b5e20"
      : trustPct >= 40
      ? "#d97706"
      : "#b71c1c";
  const trustBg =
    trustPct == null
      ? "#f5f5f5"
      : trustPct >= 67
      ? "#e8f5e9"
      : trustPct >= 40
      ? "#fff3e0"
      : "#ffebee";
  // Volume detail (7-day count, falls back to today) + week-on-week %.
  const vol = Math.max(theme.trend7d?.recent7 || 0, theme.countToday || 0);
  const pct = theme.trend7d?.pct;
  const sentiment = theme.sentimentLabel;
  return (
    <Box
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      sx={{
        position: "absolute",
        left: `calc(${xPct}% - 52px)`,
        bottom: `${yPct}%`,
        width: 104,
        cursor: "pointer",
        borderRadius: "6px",
        border: `2px solid ${active ? color : changed ? "#f97316" : "rgba(0,0,0,0.1)"}`,
        borderLeft: `4px solid ${color}`,
        bgcolor: active ? bg : "#fff",
        boxShadow: active
          ? `0 4px 16px ${color}44`
          : changed
          ? "0 0 0 2px #fdba74"
          : "0 1px 4px rgba(0,0,0,0.1)",
        p: "3px 5px",
        zIndex: active ? 10 : changed ? 4 : 2,
        transition: "all 0.15s",
        transform: active ? "scale(1.04)" : "scale(1)",
      }}
    >
      <MDTypography
        fontWeight="bold"
        sx={{
          display: "block",
          fontSize: "0.6rem",
          lineHeight: 1.2,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {theme.llmTrend?.displayName || theme.themeLabel}
      </MDTypography>
      <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "3px", mt: "2px" }}>
        {/* Primary metric — adapts to the Y-axis mode: Trust % vs volume of articles */}
        <Box
          component="span"
          sx={{
            px: "3px",
            borderRadius: "3px",
            fontSize: "0.5rem",
            fontWeight: 700,
            lineHeight: 1.4,
            bgcolor: yMode === "trust" ? trustBg : "#ede7f6",
            color: yMode === "trust" ? trustColor : "#52009b",
          }}
        >
          {yMode === "trust"
            ? trustPct != null
              ? `Trust ${trustPct}%`
              : "Unranked"
            : `${vol} art.${pct != null && pct !== 0 ? ` ${pct > 0 ? "+" : ""}${pct}%` : ""}`}
        </Box>
        {/* Trend */}
        <Box
          component="span"
          sx={{
            fontSize: "0.5rem",
            fontWeight: 600,
            lineHeight: 1.4,
            color:
              trend === "increasing" ? "#b71c1c" : trend === "decreasing" ? "#1b5e20" : "#9e9e9e",
          }}
        >
          {trend === "increasing" ? "⚠ Rising" : trend === "decreasing" ? "✓ Easing" : "~ Stable"}
        </Box>
        {/* Sentiment */}
        {sentiment && sentiment !== "neutral" && (
          <Box
            component="span"
            sx={{
              px: "3px",
              borderRadius: "3px",
              fontSize: "0.5rem",
              fontWeight: 600,
              lineHeight: 1.4,
              bgcolor: sentiment === "positive" ? "#e8f5e9" : "#ffebee",
              color: sentiment === "positive" ? "#1b5e20" : "#b71c1c",
            }}
          >
            {sentiment === "positive" ? "Positive" : "Negative"}
          </Box>
        )}
        <OriginBadge origin={theme.llmTrend?.origin} />
        {change && <ChangeMarkers change={change} size="sm" />}
      </Box>
    </Box>
  );
}

// ID127 — upside-down teardrop map pin (no house). Tip sits exactly on (x, y).
// label = a count (cluster) → shown in white; otherwise a small white centre dot.
function PinMarker({ x, y, color, label, size, active, zIndex, onClick, onMouseEnter }) {
  const w = size * 0.72;
  const h = size;
  return (
    <Box
      onMouseDown={(e) => e.stopPropagation()}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
      sx={{
        position: "absolute",
        left: x - w / 2,
        top: y - h,
        width: w,
        height: h,
        cursor: "pointer",
        zIndex,
        filter: active
          ? "drop-shadow(0 0 3px rgba(0,0,0,0.55))"
          : "drop-shadow(0 1px 2px rgba(0,0,0,0.35))",
      }}
    >
      <svg width={w} height={h} viewBox="0 0 24 32">
        <path
          d="M12 0C5.4 0 0 5.4 0 12c0 8.4 12 20 12 20s12-11.6 12-20C24 5.4 18.6 0 12 0z"
          fill={color}
          stroke="#fff"
          strokeWidth="1.5"
        />
        {label != null ? (
          <text
            x="12"
            y="12.5"
            textAnchor="middle"
            dominantBaseline="central"
            fill="#fff"
            fontSize="11"
            fontWeight="800"
          >
            {label}
          </text>
        ) : (
          <circle cx="12" cy="12" r="4.5" fill="#fff" />
        )}
      </svg>
    </Box>
  );
}

// ── Risk map: pan/zoom scatter with marker clustering + hover card ──────────────
function RiskMapChart({
  placed,
  height,
  yMode,
  gridlines,
  getGridY,
  visibleBands,
  hoveredKey,
  selectedKey,
  onHoverKey,
  onSelectKey,
  themeVol,
  autoMax,
  changeFor,
  showChange,
}) {
  const wrapRef = useRef(null);
  const [W, setW] = useState(600);
  const [view, setView] = useState({ scale: 1, tx: 0, ty: 0 });
  const dragRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [listCluster, setListCluster] = useState(null); // {x,y,members} chooser popover (ID127)
  const H = height;

  // Clamp pan so the content can never be dragged off the chart (no blank space). At zoom 1
  // there is no spare room, so tx/ty are forced to 0 (centred fit).
  const clampView = (v) => {
    const minTx = Math.min(0, W - W * v.scale);
    const minTy = Math.min(0, H - H * v.scale);
    return {
      scale: v.scale,
      tx: Math.min(0, Math.max(minTx, v.tx)),
      ty: Math.min(0, Math.max(minTy, v.ty)),
    };
  };

  // Measure width responsively.
  useEffect(() => {
    const measure = () => wrapRef.current && setW(wrapRef.current.clientWidth);
    measure();
    let ro;
    if (typeof ResizeObserver !== "undefined" && wrapRef.current) {
      ro = new ResizeObserver(measure);
      ro.observe(wrapRef.current);
    }
    window.addEventListener("resize", measure);
    return () => {
      if (ro) ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  const toScreen = (xPct, yPct) => ({
    x: (xPct / 100) * W * view.scale + view.tx,
    y: (1 - yPct / 100) * H * view.scale + view.ty,
  });

  // Wheel zoom toward the cursor (non-passive so we can preventDefault).
  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return undefined;
    const onWheel = (e) => {
      // If the wheel is over the cluster chooser list, let it scroll natively (don't zoom).
      if (e.target.closest && e.target.closest("[data-cluster-list]")) return;
      e.preventDefault();
      setListCluster(null);
      const rect = el.getBoundingClientRect();
      const cx = e.clientX - rect.left;
      const cy = e.clientY - rect.top;
      setView((v) => {
        const factor = e.deltaY < 0 ? 1.18 : 1 / 1.18;
        const ns = Math.min(24, Math.max(1, v.scale * factor));
        const k = ns / v.scale;
        return clampView({ scale: ns, tx: cx - (cx - v.tx) * k, ty: cy - (cy - v.ty) * k });
      });
    };
    el.addEventListener("wheel", onWheel, { passive: false });
    return () => el.removeEventListener("wheel", onWheel);
  }, [W, H]);

  const onMouseDown = (e) => {
    dragRef.current = { x: e.clientX, y: e.clientY, tx: view.tx, ty: view.ty, moved: false };
  };
  const onMouseMove = (e) => {
    const d = dragRef.current;
    if (!d) return;
    const dx = e.clientX - d.x;
    const dy = e.clientY - d.y;
    if (Math.abs(dx) + Math.abs(dy) > 3) {
      d.moved = true;
      if (!dragging) setDragging(true);
      if (listCluster) setListCluster(null);
    }
    setView((v) => clampView({ ...v, tx: d.tx + dx, ty: d.ty + dy }));
  };
  const endDrag = () => {
    dragRef.current = null;
    if (dragging) setDragging(false);
  };
  const zoomBy = (factor) => {
    setListCluster(null);
    setView((v) => {
      const ns = Math.min(24, Math.max(1, v.scale * factor));
      const k = ns / v.scale;
      // zoom around the chart centre
      return clampView({
        scale: ns,
        tx: W / 2 - (W / 2 - v.tx) * k,
        ty: H / 2 - (H / 2 - v.ty) * k,
      });
    });
  };
  const resetView = () => {
    setListCluster(null);
    setView({ scale: 1, tx: 0, ty: 0 });
  };

  // Cluster markers in screen space (greedy single pass). The SELECTED theme is excluded so it
  // always renders as its own teardrop pin (ID127), never hidden inside a cluster bubble.
  const allPts = placed.map((p) => ({ ...p, ...toScreen(p.xPct, p.yPct) }));
  const selectedPt = allPts.find((p) => p.theme.themeKey === selectedKey) || null;
  const pts = allPts.filter((p) => p.theme.themeKey !== selectedKey);
  const CL = 28;
  const clusters = [];
  const used = new Array(pts.length).fill(false);
  for (let i = 0; i < pts.length; i += 1) {
    if (used[i]) continue;
    const g = [pts[i]];
    used[i] = true;
    for (let j = i + 1; j < pts.length; j += 1) {
      if (used[j]) continue;
      const dx = pts[i].x - pts[j].x;
      const dy = pts[i].y - pts[j].y;
      if (dx * dx + dy * dy < CL * CL) {
        g.push(pts[j]);
        used[j] = true;
      }
    }
    const cx = g.reduce((s, p) => s + p.x, 0) / g.length;
    const cy = g.reduce((s, p) => s + p.y, 0) / g.length;
    clusters.push({ members: g, x: cx, y: cy });
  }

  // ID127 — every dot is the SAME size (no volume scaling). Selected becomes a teardrop pin.
  const DOT = 18;
  const hovered = placed.find((p) => p.theme.themeKey === hoveredKey);
  const hoveredScreen = hovered ? toScreen(hovered.xPct, hovered.yPct) : null;

  // A single theme marker: a plain coloured dot (no rating letter), or a teardrop pin when selected.
  const renderDot = (t, x, y) => {
    const rating = t.llmTrend?.matrixRating;
    const color = SCATTER_RATING_COLOR[rating] || "#90a4ae";
    const selected = selectedKey === t.themeKey;
    const active = hoveredKey === t.themeKey || selected;
    const changed = showChange && !!changeFor(t);

    // ID127 — the selected theme is rendered as an upside-down teardrop map pin.
    if (selected) {
      return (
        <PinMarker
          key={t.themeKey}
          x={x}
          y={y}
          color={color}
          label={null}
          size={36}
          active
          zIndex={27}
          onMouseEnter={() => onHoverKey(t.themeKey)}
          onClick={() => onSelectKey(null)}
        />
      );
    }

    const size = active ? DOT + 4 : DOT;
    return (
      <Box
        key={t.themeKey}
        onMouseEnter={() => onHoverKey(t.themeKey)}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={() => onSelectKey(t.themeKey)}
        sx={{
          position: "absolute",
          left: x - size / 2,
          top: y - size / 2,
          width: size,
          height: size,
          borderRadius: "50%",
          bgcolor: color,
          cursor: "pointer",
          border: active ? "2px solid #1a1a1a" : changed ? "2px solid #f97316" : "2px solid #fff",
          boxShadow: active ? `0 0 0 4px ${color}44` : "0 1px 3px rgba(0,0,0,0.3)",
          zIndex: active ? 20 : 5,
        }}
      />
    );
  };

  return (
    <Box sx={{ flex: 1 }}>
      <Box
        ref={wrapRef}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={endDrag}
        onMouseLeave={() => {
          endDrag();
          onHoverKey(null);
        }}
        sx={{
          position: "relative",
          height: H,
          bgcolor: "#fafafa",
          border: "1px solid rgba(82,0,155,0.15)",
          borderRadius: 1,
          overflow: "hidden",
          cursor: dragging ? "grabbing" : "grab",
          userSelect: "none",
        }}
      >
        {/* Zoom controls */}
        <Box sx={{ position: "absolute", top: 6, right: 6, zIndex: 30, display: "flex", gap: 0.5 }}>
          {[
            { label: "+", fn: () => zoomBy(1.4) },
            { label: "−", fn: () => zoomBy(1 / 1.4) },
            { label: "⟲", fn: resetView },
          ].map((b) => (
            <Box
              key={b.label}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={b.fn}
              sx={{
                width: 24,
                height: 24,
                borderRadius: "4px",
                bgcolor: "#fff",
                border: "1px solid rgba(82,0,155,0.3)",
                color: "#52009b",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                fontSize: "0.9rem",
                "&:hover": { bgcolor: "#ede7f6" },
              }}
            >
              {b.label}
            </Box>
          ))}
        </Box>

        {/* Y gridlines */}
        {gridlines.map((v) => {
          const y = (1 - getGridY(v) / 100) * H * view.scale + view.ty;
          if (y < 0 || y > H) return null;
          return (
            <Box
              key={v}
              sx={{
                position: "absolute",
                left: 0,
                right: 0,
                top: y,
                borderTop: "1px dashed rgba(0,0,0,0.07)",
                zIndex: 1,
              }}
            >
              <MDTypography
                sx={{
                  position: "absolute",
                  left: 2,
                  top: -7,
                  fontSize: "0.55rem",
                  color: "#aaa",
                  bgcolor: "rgba(250,250,250,0.8)",
                  px: "2px",
                }}
              >
                {yMode === "trust" ? TRUST_Y_LABELS[v] : v >= 1000 ? `${v / 1000}k` : v}
              </MDTypography>
            </Box>
          );
        })}

        {/* Markers: single dots + numbered red cluster pins (ID127) */}
        {clusters.map((c, ci) => {
          if (c.x < -60 || c.x > W + 60 || c.y < -60 || c.y > H + 60) return null;
          if (c.members.length === 1) return renderDot(c.members[0].theme, c.x, c.y);

          // Cluster → a teardrop pin coloured by its risk rating (highest-severity member),
          // with the count. Click opens a chooser list.
          const n = c.members.length;
          const order = ["E", "H", "M", "L", "VL"];
          const domRating =
            c.members
              .map((m) => m.theme.llmTrend?.matrixRating)
              .filter(Boolean)
              .sort((a, b) => order.indexOf(a) - order.indexOf(b))[0] || "M";
          return (
            <PinMarker
              key={`c${ci}`}
              x={c.x}
              y={c.y}
              color={SCATTER_RATING_COLOR[domRating] || "#90a4ae"}
              label={n}
              size={Math.min(46, 30 + n)}
              zIndex={10}
              onClick={() => setListCluster({ x: c.x, y: c.y, members: c.members })}
            />
          );
        })}

        {/* Selected theme — always its own teardrop pin, on top of any cluster (ID127) */}
        {selectedPt &&
          selectedPt.x >= -60 &&
          selectedPt.x <= W + 60 &&
          selectedPt.y >= -60 &&
          selectedPt.y <= H + 60 &&
          renderDot(selectedPt.theme, selectedPt.x, selectedPt.y)}

        {/* Cluster chooser list — "N themes at this location" → pick one (ID127) */}
        {listCluster &&
          (() => {
            const items = listCluster.members;
            const popW = Math.min(380, Math.max(300, W - 24));
            const popH = Math.min(260, 52 + items.length * 40);
            const left = Math.min(Math.max(listCluster.x - popW / 2, 6), W - popW - 6);
            const top = Math.min(Math.max(listCluster.y - popH - 14, 6), H - popH - 6);
            return (
              <Box
                data-cluster-list="1"
                onMouseDown={(e) => e.stopPropagation()}
                onMouseLeave={() => setListCluster(null)}
                sx={{
                  position: "absolute",
                  left,
                  top,
                  width: popW,
                  maxHeight: popH,
                  zIndex: 45,
                  bgcolor: "#fff",
                  border: "1px solid rgba(0,0,0,0.18)",
                  borderRadius: 1,
                  boxShadow: "0 6px 20px rgba(0,0,0,0.22)",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    px: 1.25,
                    py: 0.75,
                    bgcolor: "rgba(82,0,155,0.06)",
                    borderBottom: "1px solid rgba(0,0,0,0.08)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <MDTypography sx={{ fontSize: "0.72rem", fontWeight: 700, color: "#52009b" }}>
                    {items.length} themes here
                  </MDTypography>
                  <Box
                    onClick={() => setListCluster(null)}
                    sx={{ cursor: "pointer", color: "#888", fontSize: "0.9rem", lineHeight: 1 }}
                  >
                    ✕
                  </Box>
                </Box>
                <Box sx={{ overflowY: "auto" }}>
                  {items.map((m) => {
                    const t = m.theme;
                    const rating = t.llmTrend?.matrixRating;
                    const col = SCATTER_RATING_COLOR[rating] || "#90a4ae";
                    const tPct = t.reliabilitySummary?.trustPct;
                    const metric =
                      yMode === "trust"
                        ? tPct != null
                          ? `Trust ${tPct}%`
                          : "Unranked"
                        : `${themeVol(t)} vol`;
                    return (
                      <Box
                        key={t.themeKey}
                        onClick={() => {
                          onHoverKey(null); // make the click authoritative over any stale hover
                          onSelectKey(t.themeKey);
                          setListCluster(null);
                        }}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          px: 1.25,
                          py: 0.75,
                          cursor: "pointer",
                          borderBottom: "1px solid rgba(0,0,0,0.05)",
                          "&:hover": { bgcolor: "rgba(82,0,155,0.06)" },
                        }}
                      >
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            borderRadius: "50%",
                            bgcolor: col,
                            flexShrink: 0,
                          }}
                        />
                        <Box sx={{ minWidth: 0 }}>
                          <MDTypography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 600,
                              color: "#1a1a1a",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {t.llmTrend?.displayName || t.themeLabel || t.themeKey}
                          </MDTypography>
                          <MDTypography sx={{ fontSize: "0.62rem", color: "#888" }}>
                            {rating ? `${t.llmTrend?.matrixRatingNum ?? ""}${rating}` : "—"} ·{" "}
                            {metric}
                          </MDTypography>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            );
          })()}

        {/* Hover card */}
        {hovered &&
          hoveredScreen &&
          (() => {
            const t = hovered.theme;
            const trustPct = t.reliabilitySummary?.trustPct ?? null;
            const vol = themeVol(t);
            const pct = t.trend7d?.pct;
            const trend = t.trend7d?.direction;
            const sentiment = t.sentimentLabel;
            const left = Math.min(Math.max(hoveredScreen.x + 12, 4), W - 164);
            const top = Math.min(Math.max(hoveredScreen.y - 10, 4), H - 90);
            return (
              <Box
                sx={{
                  position: "absolute",
                  left,
                  top,
                  width: 156,
                  zIndex: 40,
                  pointerEvents: "none",
                  bgcolor: "#fff",
                  border: "1px solid rgba(0,0,0,0.15)",
                  borderLeft: `4px solid ${
                    SCATTER_RATING_COLOR[t.llmTrend?.matrixRating] || "#90a4ae"
                  }`,
                  borderRadius: "6px",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
                  p: "6px 8px",
                }}
              >
                <MDTypography
                  fontWeight="bold"
                  sx={{ fontSize: "0.7rem", lineHeight: 1.2, mb: 0.25 }}
                >
                  {t.llmTrend?.displayName || t.themeLabel}
                </MDTypography>
                <MDTypography sx={{ fontSize: "0.62rem", color: "#52009b", fontWeight: 700 }}>
                  {yMode === "trust"
                    ? trustPct != null
                      ? `Trust ${trustPct}%`
                      : "Unranked"
                    : `${vol} articles${
                        pct != null && pct !== 0 ? ` (${pct > 0 ? "+" : ""}${pct}%)` : ""
                      }`}
                </MDTypography>
                <Box sx={{ display: "flex", gap: 0.75, mt: 0.25, flexWrap: "wrap" }}>
                  <Box
                    component="span"
                    sx={{
                      fontSize: "0.58rem",
                      fontWeight: 600,
                      color:
                        trend === "increasing"
                          ? "#b71c1c"
                          : trend === "decreasing"
                          ? "#1b5e20"
                          : "#9e9e9e",
                    }}
                  >
                    {trend === "increasing"
                      ? "⚠ Rising"
                      : trend === "decreasing"
                      ? "✓ Easing"
                      : "~ Stable"}
                  </Box>
                  {sentiment && sentiment !== "neutral" && (
                    <Box
                      component="span"
                      sx={{
                        fontSize: "0.58rem",
                        fontWeight: 600,
                        color: sentiment === "positive" ? "#1b5e20" : "#b71c1c",
                      }}
                    >
                      {sentiment === "positive" ? "Positive" : "Negative"}
                    </Box>
                  )}
                </Box>
              </Box>
            );
          })()}
      </Box>

      {/* X-axis bands — pan/scale horizontally with the view */}
      <Box sx={{ position: "relative", height: 36, mt: "4px", overflow: "hidden" }}>
        {visibleBands.map((r, bi) => {
          const n = visibleBands.length;
          const left = (bi / n) * W * view.scale + view.tx;
          const width = (1 / n) * W * view.scale;
          return (
            <Box
              key={r}
              sx={{
                position: "absolute",
                left,
                width,
                top: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: `${SCATTER_RATING_COLOR[r]}15`,
                borderTop: `3px solid ${SCATTER_RATING_COLOR[r]}`,
              }}
            >
              <Box
                sx={{
                  width: 26,
                  height: 26,
                  borderRadius: "50%",
                  bgcolor: SCATTER_RATING_COLOR[r],
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "0.72rem",
                  fontWeight: 800,
                }}
              >
                {r}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

// ID151 — sort helpers for the summary table beneath the radar.
const RATING_SEV = { E: 5, H: 4, M: 3, L: 2, VL: 1 };
const TREND_ORDER = { increasing: 2, stable: 1, decreasing: 0 };
const themeSortValue = (t, col) => {
  if (col === "theme") return (t.llmTrend?.displayName || t.themeLabel || "").toLowerCase();
  if (col === "category") return (t.llmTrend?.consequenceTypeLabel || "").toLowerCase();
  if (col === "rating") return RATING_SEV[t.llmTrend?.matrixRating] || 0;
  if (col === "trend") return TREND_ORDER[t.trend7d?.direction] ?? 1;
  return 0;
};
function sortThemeRows(rows, sort) {
  if (!sort.col) return rows;
  return [...rows].sort((a, b) => {
    const va = themeSortValue(a, sort.col);
    const vb = themeSortValue(b, sort.col);
    const c = typeof va === "number" ? va - vb : String(va).localeCompare(String(vb));
    return sort.dir === "asc" ? c : -c;
  });
}
function SortableTh({ col, width, sort, onSort, children }) {
  const active = sort.col === col;
  return (
    <TableCell
      sx={{ fontWeight: 700, color: "#52009b", fontSize: "0.75rem", bgcolor: "#f4eefb", width }}
      sortDirection={active ? sort.dir : false}
    >
      <TableSortLabel
        active={active}
        direction={active ? sort.dir : "asc"}
        onClick={() => onSort(col)}
        sx={{
          color: "#52009b !important",
          "& .MuiTableSortLabel-icon": { color: "#52009b !important" },
        }}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  );
}
SortableTh.propTypes = {
  col: PropTypes.string.isRequired,
  width: PropTypes.number,
  sort: PropTypes.shape({ col: PropTypes.string, dir: PropTypes.string }).isRequired,
  onSort: PropTypes.func.isRequired,
  children: PropTypes.node,
};
SortableTh.defaultProps = { width: undefined, children: null };

function HorizonScatterDashboard({
  themes,
  todayUtc,
  activeRisks,
  loading,
  error,
  onRefresh,
  evalCriteria,
  onOpenWatchlistRisk,
  onOpenThemeDetail,
}) {
  const [yMode, setYMode] = useState("trust");
  const [zoomMax, setZoomMax] = useState(null);
  const [hoveredKey, setHoveredKey] = useState(null);
  const [selectedKey, setSelectedKey] = useState(null);
  // Top filters
  // ID129 — risk & trust are now MULTI-select (tick boxes); [] = all.
  const [filterRating, setFilterRating] = useState([]); // [] = all, else subset of E/H/M/L/VL
  const [filterTier, setFilterTier] = useState([]); // [] = all, else subset of "6".."1"
  // ID129 — volume is a "greater than or equal" COUNT (actual article count), not a % slider.
  const [volMin, setVolMin] = useState(0);
  // ID151 — sort the summary table beneath the radar by any column heading. col=null keeps the
  // default order (rated themes first, then unrated).
  const [tableSort, setTableSort] = useState({ col: null, dir: "asc" });
  const handleTableSort = (col) =>
    setTableSort((s) => ({ col, dir: s.col === col && s.dir === "asc" ? "desc" : "asc" }));
  const { showChange, setShowChange, changeFor, summary } = useThemeChanges(
    "horizonDashChanges",
    themes,
    todayUtc
  );

  // The detail panel follows the cursor on hover, but falls back to the SELECTED theme when not
  // hovering — so the default most-extreme theme shows on load, and clicking a theme (teardrop, the
  // cluster chooser list, or the side list) keeps it open. Hover just previews on top of that.
  const activeKey = hoveredKey || selectedKey;
  const allRated = (themes || []).filter((t) => t.llmTrend?.matrixRating);
  const linkedSet = new Set((activeRisks || []).map((r) => r.linkedHorizonTheme).filter(Boolean));
  // ID154 — map each linked theme to its watchlist risk so the ⚑ flag can open the risk's details.
  const linkedRiskByTheme = new Map();
  (activeRisks || []).forEach((r) => {
    const k = r.linkedHorizonTheme;
    if (k && !linkedRiskByTheme.has(k)) {
      linkedRiskByTheme.set(k, {
        id: String(r._id || r.id || ""),
        title: r.Title || r.title || "Watchlist risk",
      });
    }
  });
  const linkedRiskFor = (t) =>
    t
      ? linkedRiskByTheme.get(t.themeKey) ||
        (t.parentThemeTag ? linkedRiskByTheme.get(t.parentThemeTag) : null) ||
        null
      : null;
  const activeTheme = (themes || []).find((t) => t.themeKey === activeKey) || null;
  // "Volume" = 7-day article count (falls back to today). countToday alone is often 0
  // — using it pinned every card to the bottom of the plot.
  const themeVol = (t) => Math.max(t.trend7d?.recent7 || 0, t.countToday || 0);
  // Max volume across ALL rated themes (stable, so the volume % filter is consistent).
  const autoMax = Math.max(...allRated.map((t) => themeVol(t)), 2);
  const maxCount = zoomMax || autoMax;
  const volFiltered = volMin > 0;

  // Apply the top filters (risk rating, trustworthiness tier, min volume count). Empty arrays = all.
  const ratedThemes = allRated.filter((t) => {
    if (filterRating.length && !filterRating.includes(t.llmTrend?.matrixRating)) return false;
    if (filterTier.length && !filterTier.includes(String(t.reliabilitySummary?.dominantTier || "")))
      return false;
    if (volMin > 0 && themeVol(t) < volMin) return false;
    return true;
  });
  // On first load, auto-highlight the most critical theme (top-right: highest rating, then
  // highest volume) so it opens as a selected teardrop pin.
  const autoSelectedRef = useRef(false);
  useEffect(() => {
    if (autoSelectedRef.current) return;
    if (!ratedThemes.length) return;
    autoSelectedRef.current = true;
    const order = { E: 0, H: 1, M: 2, L: 3, VL: 4 };
    const best = [...ratedThemes].sort((a, b) => {
      const ra = order[a.llmTrend?.matrixRating] ?? 5;
      const rb = order[b.llmTrend?.matrixRating] ?? 5;
      if (ra !== rb) return ra - rb;
      return themeVol(b) - themeVol(a);
    })[0];
    if (best) setSelectedKey(best.themeKey);
  }, [ratedThemes]);

  // Unrated themes only make sense when no risk/volume filter is active.
  const unratedThemes =
    filterRating.length || filterTier.length || volFiltered
      ? []
      : (themes || []).filter((t) => !t.llmTrend?.matrixRating);

  // X-axis bands collapse to the selected ratings when a Risk filter is active (kept in band order).
  const ALL_BANDS = ["VL", "L", "M", "H", "E"];
  const visibleBands = filterRating.length
    ? ALL_BANDS.filter((b) => filterRating.includes(b))
    : ALL_BANDS;

  // ID — granular within-band positioning. Each prioritisation-matrix cell has a 1..N number
  // (consequence level + plausibility row score, e.g. "9E"). Build letter → [min,max] number from
  // the matrix so a theme can be placed precisely inside its band instead of stacking on the centre.
  const eqRows = evalCriteria?.prioritisationMatrix?.rows || [];
  const eqLevels = evalCriteria?.consequenceTable?.levels || [];
  const eqPlaus = evalCriteria?.plausibilityTable?.rows || [];
  const letterNumRange = {};
  eqRows.forEach((row) => {
    const plausIdx = eqPlaus.findIndex((r) => r.id === row.id);
    if (plausIdx < 0) return;
    (row.cells || []).forEach((cell) => {
      const levelIdx = eqLevels.findIndex((l) => l.id === cell.colId);
      if (levelIdx < 0 || !cell.rating) return;
      const num = levelIdx + 1 + (eqPlaus.length - 1 - plausIdx);
      const r = letterNumRange[cell.rating] || { min: num, max: num };
      r.min = Math.min(r.min, num);
      r.max = Math.max(r.max, num);
      letterNumRange[cell.rating] = r;
    });
  });

  // X% for a theme: centre of its letter band, nudged by the granular matrix number so finer
  // ratings (e.g. 9E vs 11E) spread within the band. Falls back to band centre when no number.
  const BAND_PAD = 0.16; // fraction of band width kept clear on each edge
  const xOfTheme = (th) => {
    const rating = th.llmTrend?.matrixRating;
    const idx = visibleBands.indexOf(rating);
    if (idx < 0) return 50;
    const bandW = 100 / visibleBands.length;
    const left = idx * bandW;
    const num = th.llmTrend?.matrixRatingNum;
    const rng = letterNumRange[rating];
    const frac =
      num != null && rng && rng.max > rng.min ? (num - rng.min) / (rng.max - rng.min) : 0.5;
    return left + bandW * (BAND_PAD + frac * (1 - 2 * BAND_PAD));
  };

  // ID127 — place each theme at the CENTRE of its (rating × y-band) cell, then ring any
  // extra themes out concentrically. The spread is tiny so same-cell themes stack on one
  // point at zoom 1 (→ a single numbered cluster pin) and only fan apart as you zoom in.
  const RING_STEP = 1.0; // % radius added per concentric ring
  const yBandOf = (t) =>
    yMode === "trust"
      ? t.reliabilitySummary?.dominantTier || 0 // 0 = Unranked band
      : Math.round(scatterLogY(themeVol(t), maxCount) / 8);
  const yCenterOf = (t) =>
    yMode === "trust"
      ? factualY(t.reliabilitySummary?.dominantTier || 0)
      : Math.min(92, Math.max(8, Math.round(scatterLogY(themeVol(t), maxCount) / 8) * 8));

  // Concentric offsets: index 0 = centre, then rings of 6, 12, 18 … slots.
  const ringOffsets = (n) => {
    const out = [{ dx: 0, dy: 0 }];
    let ring = 1;
    while (out.length < n) {
      const slots = ring * 6;
      for (let k = 0; k < slots && out.length < n; k += 1) {
        const ang = (k / slots) * 2 * Math.PI;
        out.push({ dx: ring * RING_STEP * Math.cos(ang), dy: ring * RING_STEP * Math.sin(ang) });
      }
      ring += 1;
    }
    return out;
  };

  // Cluster only themes that share the SAME granular rating (letter + number) and y-band, so that
  // 9E and 11E sit apart while identical ratings still stack into one numbered teardrop pin.
  const cells = new Map();
  ratedThemes.forEach((t) => {
    const num = t.llmTrend?.matrixRatingNum;
    const key = `${t.llmTrend.matrixRating}:${num == null ? "x" : num}|${yBandOf(t)}`;
    if (!cells.has(key)) cells.set(key, []);
    cells.get(key).push(t);
  });
  const placed = [];
  cells.forEach((members) => {
    const sorted = members.slice().sort((a, b) => a.themeKey.localeCompare(b.themeKey));
    const offs = ringOffsets(sorted.length);
    sorted.forEach((t, i) => {
      placed.push({
        theme: t,
        xPct: Math.min(98, Math.max(2, xOfTheme(t) + offs[i].dx)),
        yPct: Math.min(94, Math.max(6, yCenterOf(t) + offs[i].dy)),
      });
    });
  });

  const gridlines =
    yMode === "trust"
      ? TRUST_GRIDLINES
      : SCATTER_Y_GRIDLINES.filter((v) => v <= maxCount * 1.5 && v > 0);
  const getGridY = (v) => (yMode === "trust" ? factualY(v) : scatterLogY(v, maxCount));

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <MDTypography variant="h6" fontWeight="medium">
          Emerging Themes
        </MDTypography>
        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", alignItems: "center" }}>
          <ChangeToggle
            on={showChange}
            onClick={() => setShowChange((s) => !s)}
            summary={summary}
          />
          <Button
            size="small"
            variant="outlined"
            onClick={onRefresh}
            sx={{
              color: "#52009b",
              borderColor: "#52009b",
              fontSize: "0.72rem",
              textTransform: "none",
            }}
          >
            Refresh
          </Button>
        </Box>
      </Box>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress sx={{ color: "#52009b" }} />
        </Box>
      )}
      {!loading && error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {!loading && !error && (
        <>
          {/* Filters — top centre of the chart; each control has a clear caption label above it. */}
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "center",
              gap: 1.5,
              mb: 1.5,
              flexWrap: "wrap",
            }}
          >
            {/* Risk level — multi-select */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.4 }}>
              <MDTypography sx={FILTER_LABEL_SX}>Risk level</MDTypography>
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <Select
                  multiple
                  value={filterRating}
                  onChange={(e) =>
                    setFilterRating(
                      typeof e.target.value === "string"
                        ? e.target.value.split(",")
                        : e.target.value
                    )
                  }
                  renderValue={(sel) => (sel.length === 0 ? "All" : sel.join(", "))}
                  displayEmpty
                  sx={FILTER_INPUT_SX}
                >
                  {["E", "H", "M", "L", "VL"].map((r) => (
                    <MenuItem key={r} value={r} sx={{ py: 0 }}>
                      <Checkbox size="small" checked={filterRating.includes(r)} />
                      {r}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            {/* Trustworthiness — multi-select */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.4 }}>
              <MDTypography sx={FILTER_LABEL_SX}>Trustworthiness</MDTypography>
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <Select
                  multiple
                  value={filterTier}
                  onChange={(e) =>
                    setFilterTier(
                      typeof e.target.value === "string"
                        ? e.target.value.split(",")
                        : e.target.value
                    )
                  }
                  renderValue={(sel) =>
                    sel.length === 0
                      ? "All"
                      : sel.map((t) => FACTUAL_RANK_META[t]?.label || t).join(", ")
                  }
                  displayEmpty
                  sx={FILTER_INPUT_SX}
                >
                  {["6", "5", "4", "3", "2", "1"].map((t) => (
                    <MenuItem key={t} value={t} sx={{ py: 0 }}>
                      <Checkbox size="small" checked={filterTier.includes(t)} />
                      {FACTUAL_RANK_META[t].label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            {/* Min volume — actual article count ("greater than or equal"), ID129 */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.4 }}>
              <MDTypography sx={FILTER_LABEL_SX}>Min volume (articles)</MDTypography>
              <TextField
                size="small"
                type="number"
                value={volMin || ""}
                placeholder="Any"
                onChange={(e) => {
                  const n = parseInt(e.target.value, 10);
                  setVolMin(Number.isFinite(n) && n > 0 ? n : 0);
                }}
                inputProps={{ min: 0, step: 1 }}
                sx={{ width: 110, ...FILTER_INPUT_SX }}
              />
            </Box>
            {(filterRating.length || filterTier.length || volFiltered) && (
              <Box
                onClick={() => {
                  setFilterRating([]);
                  setFilterTier([]);
                  setVolMin(0);
                }}
                sx={{
                  cursor: "pointer",
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  color: "#52009b",
                  height: 34,
                  display: "flex",
                  alignItems: "center",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                ✕ Clear
              </Box>
            )}
          </Box>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            {/* Scatter plot — fixed width so it never reflows on hover (was md 12↔7, which
                moved the dots out from under the cursor and caused flicker) */}
            <Grid item xs={12} md={8}>
              <Box sx={{ display: "flex" }}>
                {/* Y-axis toggle — vertical Trustworthiness / Volume buttons on the left */}
                <Box
                  sx={{
                    width: 44,
                    flexShrink: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1.5,
                    mb: "36px",
                  }}
                >
                  {[
                    { key: "trust", label: "Trustworthiness" },
                    { key: "volume", label: "Volume of articles" },
                  ].map((o) => (
                    <Box
                      key={o.key}
                      onClick={() => setYMode(o.key)}
                      sx={{
                        writingMode: "vertical-rl",
                        transform: "rotate(180deg)",
                        px: "5px",
                        py: 1,
                        borderRadius: "6px",
                        border: "1px solid",
                        borderColor: yMode === o.key ? "#c2185b" : "rgba(0,0,0,0.25)",
                        bgcolor: yMode === o.key ? "#fbe4f3" : "#fff",
                        color: yMode === o.key ? "#c2185b" : "#555",
                        fontSize: "0.72rem",
                        fontWeight: 600,
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        "&:hover": { borderColor: "#c2185b" },
                      }}
                    >
                      {o.label}
                    </Box>
                  ))}
                </Box>
                {/* Risk map — pan/zoom scatter with clustering + hover card */}
                <RiskMapChart
                  placed={placed}
                  height={520}
                  yMode={yMode}
                  gridlines={gridlines}
                  getGridY={getGridY}
                  visibleBands={visibleBands}
                  hoveredKey={hoveredKey}
                  selectedKey={selectedKey}
                  onHoverKey={setHoveredKey}
                  onSelectKey={setSelectedKey}
                  themeVol={themeVol}
                  autoMax={autoMax}
                  changeFor={changeFor}
                  showChange={showChange}
                />
              </Box>
            </Grid>

            {/* Detail panel — always rendered so the chart keeps a fixed width and
                does not reflow (and flicker) when a theme becomes active on hover */}
            <Grid item xs={12} md={4}>
              {activeTheme ? (
                <Box
                  sx={{
                    border: "1px solid rgba(82,0,155,0.2)",
                    borderRadius: 2,
                    p: 2,
                    position: "relative",
                    height: "100%",
                    minHeight: 200,
                  }}
                >
                  <IconButton
                    size="small"
                    onClick={() => setSelectedKey(null)}
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      color: "#999",
                      fontSize: "0.75rem",
                      p: 0.5,
                    }}
                  >
                    ✕
                  </IconButton>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.75,
                      mb: 1,
                      flexWrap: "wrap",
                      pr: 3,
                    }}
                  >
                    {activeTheme.llmTrend?.matrixRating && (
                      <Box
                        sx={{
                          width: 34,
                          height: 34,
                          borderRadius: "7px",
                          bgcolor: SCATTER_RATING_COLOR[activeTheme.llmTrend.matrixRating],
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                          fontSize: "0.9rem",
                          fontWeight: 800,
                          flexShrink: 0,
                        }}
                      >
                        {`${activeTheme.llmTrend.matrixRatingNum ?? ""}${
                          activeTheme.llmTrend.matrixRating
                        }`}
                      </Box>
                    )}
                    <Box
                      sx={{
                        px: "7px",
                        py: "2px",
                        borderRadius: "4px",
                        fontSize: "0.7rem",
                        fontWeight: 700,
                        bgcolor: "#ede7f6",
                        color: "#52009b",
                      }}
                    >
                      {activeTheme.countToday || 0} alerts
                      {activeTheme.trend7d?.pct != null && activeTheme.trend7d.pct !== 0
                        ? ` (${activeTheme.trend7d.pct > 0 ? "+" : ""}${activeTheme.trend7d.pct}%)`
                        : ""}
                    </Box>
                    {activeTheme.trend7d?.direction && activeTheme.trend7d.direction !== "stable" && (
                      <Box
                        sx={{
                          px: "7px",
                          py: "2px",
                          borderRadius: "4px",
                          fontSize: "0.7rem",
                          fontWeight: 700,
                          bgcolor:
                            activeTheme.trend7d.direction === "increasing" ? "#ffebee" : "#e8f5e9",
                          color:
                            activeTheme.trend7d.direction === "increasing" ? "#b71c1c" : "#1b5e20",
                        }}
                      >
                        {activeTheme.trend7d.direction === "increasing" ? "⚠ Rising" : "✓ Easing"}
                      </Box>
                    )}
                    {activeTheme.sentimentLabel && activeTheme.sentimentLabel !== "neutral" && (
                      <Box
                        sx={{
                          px: "7px",
                          py: "2px",
                          borderRadius: "4px",
                          fontSize: "0.7rem",
                          fontWeight: 700,
                          bgcolor:
                            activeTheme.sentimentLabel === "positive" ? "#e8f5e9" : "#ffebee",
                          color: activeTheme.sentimentLabel === "positive" ? "#1b5e20" : "#b71c1c",
                        }}
                      >
                        {activeTheme.sentimentLabel === "positive" ? "Positive" : "Negative"}
                      </Box>
                    )}
                    {linkedSet.has(activeTheme.themeKey) &&
                      (() => {
                        const lr = linkedRiskFor(activeTheme);
                        return (
                          <MuiTooltip
                            title={
                              lr
                                ? `Open linked watchlist risk: ${lr.title}`
                                : "Linked to a watchlist risk"
                            }
                            placement="top"
                          >
                            <Box
                              onClick={() => lr?.id && onOpenWatchlistRisk?.(lr.id)}
                              sx={{
                                px: "7px",
                                py: "2px",
                                borderRadius: "4px",
                                fontSize: "0.7rem",
                                fontWeight: 700,
                                bgcolor: "#ede7f6",
                                color: "#52009b",
                                border: "1px solid #ce93d8",
                                cursor: lr?.id ? "pointer" : "default",
                                "&:hover": lr?.id ? { bgcolor: "#e1d4f5" } : undefined,
                              }}
                            >
                              ⚑ Watchlist
                            </Box>
                          </MuiTooltip>
                        );
                      })()}
                    {(activeTheme.relationshipTags || []).slice(0, 2).map((tag) => (
                      <Box
                        key={tag.criteriaLabel}
                        sx={{
                          px: "7px",
                          py: "2px",
                          borderRadius: "4px",
                          fontSize: "0.68rem",
                          fontWeight: 600,
                          bgcolor: "#f5f5f5",
                          color: "#374151",
                          border: "1px solid rgba(0,0,0,0.1)",
                        }}
                      >
                        {tag.criteriaLabel}
                      </Box>
                    ))}
                    <OriginBadge origin={activeTheme.llmTrend?.origin} size="large" />
                  </Box>

                  <MDTypography variant="subtitle1" fontWeight="bold" sx={{ mb: 0.5 }}>
                    {activeTheme.llmTrend?.displayName || activeTheme.themeLabel}
                  </MDTypography>

                  {/* Link to the full Emerging Theme details page for this theme. */}
                  <Box
                    component="span"
                    onClick={() => onOpenThemeDetail?.(activeTheme.themeKey)}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.25,
                      mb: 1.5,
                      fontSize: "0.78rem",
                      fontWeight: 700,
                      color: "#52009b",
                      cursor: "pointer",
                      "&:hover": { textDecoration: "underline" },
                    }}
                  >
                    View full theme details →
                  </Box>

                  {activeTheme.summary && (
                    <Box sx={{ mb: 1.5 }}>
                      <MDTypography
                        variant="caption"
                        fontWeight="bold"
                        sx={{ display: "block", mb: 0.25, color: "#374151" }}
                      >
                        What&apos;s happening
                      </MDTypography>
                      <MDTypography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: "0.8rem", lineHeight: 1.6 }}
                      >
                        {activeTheme.summary.length > 420
                          ? `${activeTheme.summary.slice(0, 420)}…`
                          : activeTheme.summary}
                      </MDTypography>
                    </Box>
                  )}
                  {activeTheme.whyItMatters && (
                    <Box>
                      <MDTypography
                        variant="caption"
                        fontWeight="bold"
                        sx={{ display: "block", mb: 0.25, color: "#374151" }}
                      >
                        Why it matters
                      </MDTypography>
                      <MDTypography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: "0.8rem", lineHeight: 1.6 }}
                      >
                        {activeTheme.whyItMatters.length > 420
                          ? `${activeTheme.whyItMatters.slice(0, 420)}…`
                          : activeTheme.whyItMatters}
                      </MDTypography>
                    </Box>
                  )}
                </Box>
              ) : (
                <Box
                  sx={{
                    border: "1px dashed rgba(82,0,155,0.25)",
                    borderRadius: 2,
                    p: 2,
                    height: "100%",
                    minHeight: 200,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    color: "#9ca3af",
                    fontSize: "0.85rem",
                  }}
                >
                  Hover or click a theme to see its details
                </Box>
              )}
            </Grid>
          </Grid>

          {/* Summary table — fixed-height scroll area with a sticky header so the list
              stays manageable no matter how many themes there are */}
          <Box
            sx={{
              border: "1px solid rgba(82,0,155,0.15)",
              borderRadius: 1,
              overflow: "auto",
              maxHeight: 420,
            }}
          >
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <SortableTh col="theme" sort={tableSort} onSort={handleTableSort}>
                    Emerging Theme
                  </SortableTh>
                  <SortableTh col="category" sort={tableSort} onSort={handleTableSort}>
                    Category
                  </SortableTh>
                  <SortableTh col="rating" width={90} sort={tableSort} onSort={handleTableSort}>
                    Risk Rating
                  </SortableTh>
                  <SortableTh col="trend" width={110} sort={tableSort} onSort={handleTableSort}>
                    Trend
                  </SortableTh>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortThemeRows([...ratedThemes, ...unratedThemes], tableSort).map((t) => {
                  const rating = t.llmTrend?.matrixRating;
                  const dir = t.trend7d?.direction;
                  const cat = t.llmTrend?.consequenceTypeLabel || "";
                  return (
                    <TableRow
                      key={t.themeKey}
                      hover
                      sx={{
                        cursor: "pointer",
                        bgcolor: activeKey === t.themeKey ? "rgba(82,0,155,0.04)" : undefined,
                      }}
                      onClick={() => setSelectedKey(activeKey === t.themeKey ? null : t.themeKey)}
                    >
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.75,
                            flexWrap: "wrap",
                          }}
                        >
                          <MDTypography
                            variant="body2"
                            fontWeight={600}
                            sx={{ fontSize: "0.8rem" }}
                          >
                            {t.llmTrend?.displayName || t.themeLabel}
                          </MDTypography>
                          {showChange && <ChangeMarkers change={changeFor(t)} size="md" />}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <MDTypography variant="caption" color="text.secondary">
                          {cat}
                        </MDTypography>
                      </TableCell>
                      <TableCell>
                        {rating ? (
                          <Box
                            sx={{
                              display: "inline-flex",
                              px: "7px",
                              py: "2px",
                              borderRadius: "4px",
                              fontSize: "0.68rem",
                              fontWeight: 800,
                              bgcolor: SCATTER_RATING_COLOR[rating],
                              color: "#fff",
                            }}
                          >
                            {rating}
                          </Box>
                        ) : (
                          <MDTypography variant="caption" color="text.disabled">
                            Unrated
                          </MDTypography>
                        )}
                      </TableCell>
                      <TableCell>
                        {dir && dir !== "stable" ? (
                          <Box
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 600,
                              color: dir === "increasing" ? "#b71c1c" : "#1b5e20",
                            }}
                          >
                            {dir === "increasing" ? "⚠ Rising" : "✓ Easing"}
                          </Box>
                        ) : (
                          <MDTypography variant="caption" color="text.secondary">
                            ~ Stable
                          </MDTypography>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Box>
        </>
      )}
    </Box>
  );
}
HorizonScatterDashboard.propTypes = {
  themes: PropTypes.arrayOf(PropTypes.object),
  activeRisks: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  error: PropTypes.string,
  onRefresh: PropTypes.func.isRequired,
  evalCriteria: PropTypes.object,
  onOpenWatchlistRisk: PropTypes.func,
  onOpenThemeDetail: PropTypes.func,
};

function HorizonReactDashboard({
  summary,
  themes,
  activeRisks,
  loading,
  error,
  onRefresh,
  evalCriteria,
}) {
  const s = summary || {};
  const t = themes || [];
  const risks = activeRisks || [];
  const ec = evalCriteria || {};

  const linkedThemeKeys = new Set(risks.map((r) => r.linkedHorizonTheme).filter(Boolean));

  // Group themes by matrix rating
  const byRating = {};
  RATING_ORDER.forEach((r) => {
    byRating[r] = [];
  });
  const unrated = [];
  t.forEach((th) => {
    const r = th.llmTrend?.matrixRating;
    if (r && byRating[r]) byRating[r].push(th);
    else unrated.push(th);
  });

  // Attention: E or H rated themes that are also accelerating
  const attentionThemes = [...byRating.E, ...byRating.H].filter(
    (th) => th.trend7d?.direction === "increasing"
  );

  // Unmonitored: no rating yet, has recent coverage, not on watch list
  const unmonitored = unrated
    .filter((th) => !linkedThemeKeys.has(th.themeKey) && (th.trend7d?.recent7 || 0) > 0)
    .sort((a, b) => (b.trend7d?.recent7 || 0) - (a.trend7d?.recent7 || 0));

  // ── Prioritisation matrix grid ──────────────────────────────────────────────
  const pRows = ec.plausibilityTable?.rows || [];
  const cLevels = ec.consequenceTable?.levels || [];
  const matrixRows = ec.prioritisationMatrix?.rows || [];

  // Cell rating lookup: plausibilityRowId:consequenceLevelId → rating
  const cellRatingMap = {};
  matrixRows.forEach((row) => {
    (row.cells || []).forEach((cell) => {
      cellRatingMap[`${row.id}:${cell.colId}`] = cell.rating;
    });
  });

  // Theme placement: match plausibilityRating text → pRow id, consequenceLevelLabel → cLevel id
  const themesInCell = {};
  t.forEach((th) => {
    const pr = th.llmTrend?.plausibilityRating;
    const cl = th.llmTrend?.consequenceLevelLabel;
    if (!pr || !cl) return;
    const pRow = pRows.find((r) => r.rating === pr);
    const cCol = cLevels.find((l) => l.label === cl);
    if (!pRow || !cCol) return;
    const key = `${pRow.id}:${cCol.id}`;
    if (!themesInCell[key]) themesInCell[key] = [];
    themesInCell[key].push(th);
  });

  const showMatrix = pRows.length > 0 && cLevels.length > 0;

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2.5 }}>
        <MDTypography variant="h6" fontWeight="medium" color="text">
          Risk Intelligence Dashboard
        </MDTypography>
        <Button
          variant="outlined"
          size="small"
          onClick={onRefresh}
          sx={{ borderColor: "#52009b", color: "#52009b" }}
        >
          Refresh
        </Button>
      </Box>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress sx={{ color: "#52009b" }} />
        </Box>
      )}
      {!loading && error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {!loading && !error && (
        <>
          {/* ── Rating metric cards ── */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            {RATING_ORDER.map((r) => {
              const cfg = RATING_CONFIG[r];
              return (
                <Grid item xs={6} sm={4} md key={r}>
                  <Card
                    variant="outlined"
                    sx={{
                      borderColor: cfg.border,
                      borderTopWidth: 4,
                      borderTopColor: cfg.color,
                      borderTopStyle: "solid",
                    }}
                  >
                    <CardContent sx={{ pb: "12px !important" }}>
                      <MDTypography
                        variant="h3"
                        fontWeight="bold"
                        sx={{ color: cfg.color, lineHeight: 1.1 }}
                      >
                        {byRating[r].length}
                      </MDTypography>
                      <MDTypography variant="caption" fontWeight="bold" sx={{ color: cfg.color }}>
                        {cfg.label}
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: "block" }}
                      >
                        theme{byRating[r].length !== 1 ? "s" : ""}
                      </MDTypography>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
            <Grid item xs={6} sm={4} md>
              <Card variant="outlined" sx={{ borderColor: "rgba(82,0,155,0.2)" }}>
                <CardContent sx={{ pb: "12px !important" }}>
                  <MDTypography
                    variant="h3"
                    fontWeight="bold"
                    sx={{ color: "#52009b", lineHeight: 1.1 }}
                  >
                    {unrated.length}
                  </MDTypography>
                  <MDTypography variant="caption" fontWeight="bold" sx={{ color: "#52009b" }}>
                    Unrated
                  </MDTypography>
                  <MDTypography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                    not yet classified
                  </MDTypography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* ── Attention Required ── */}
          {attentionThemes.length > 0 && (
            <Card
              variant="outlined"
              sx={{ mb: 3, borderColor: "#c62828", borderLeftWidth: 4, borderLeftStyle: "solid" }}
            >
              <CardContent>
                <MDTypography
                  variant="subtitle2"
                  fontWeight="bold"
                  sx={{ mb: 1.5, color: "#c62828" }}
                >
                  ⚠ Attention Required — {attentionThemes.length} Extreme/High theme
                  {attentionThemes.length > 1 ? "s" : ""} accelerating
                </MDTypography>
                {attentionThemes.map((th, i) => {
                  const linkedRisks = risks.filter((r) => r.linkedHorizonTheme === th.themeKey);
                  return (
                    <Box key={th.themeKey}>
                      {i > 0 && <Divider sx={{ my: 1 }} />}
                      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.25 }}>
                            <RatingBadge rating={th.llmTrend?.matrixRating} />
                            <MDTypography variant="body2" fontWeight="medium">
                              {th.themeLabel}
                            </MDTypography>
                          </Box>
                          <MDTypography variant="caption" color="text.secondary">
                            ↑ +{th.trend7d?.pct}% this week · {th.countToday} alerts today
                            {linkedRisks.length > 0
                              ? ` · Risk: ${linkedRisks.map((r) => r.Title).join(", ")}`
                              : ""}
                            {th.llmTrend?.consequenceTypeLabel
                              ? ` · ${th.llmTrend.consequenceTypeLabel}`
                              : ""}
                            {th.llmTrend?.plausibilityRating
                              ? ` · ${th.llmTrend.plausibilityRating}`
                              : ""}
                          </MDTypography>
                          {th.whyItMatters && (
                            <MDTypography
                              variant="caption"
                              sx={{ display: "block", fontStyle: "italic", color: "#555", mt: 0.5 }}
                            >
                              {th.whyItMatters.length > 220
                                ? `${th.whyItMatters.slice(0, 220)}…`
                                : th.whyItMatters}
                            </MDTypography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
              </CardContent>
            </Card>
          )}

          {/* ── Prioritisation matrix grid ── */}
          {showMatrix && (
            <Card variant="outlined" sx={{ mb: 3, borderColor: "rgba(82,0,155,0.2)" }}>
              <CardContent>
                <MDTypography variant="subtitle2" fontWeight="bold" sx={{ mb: 1.5 }}>
                  Prioritisation matrix — themes by consequence × plausibility
                </MDTypography>
                <Box sx={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", width: "100%", minWidth: 480 }}>
                    <thead>
                      <tr>
                        <td
                          style={{
                            width: 130,
                            padding: "4px 8px",
                            fontSize: 11,
                            fontWeight: 700,
                            color: "#52009b",
                            verticalAlign: "bottom",
                          }}
                        >
                          ↓ Plausibility · Consequence →
                        </td>
                        {cLevels.map((col) => (
                          <td
                            key={col.id}
                            style={{
                              padding: "4px 6px",
                              textAlign: "center",
                              fontSize: 11,
                              fontWeight: 700,
                              color: "#374151",
                              borderBottom: "2px solid rgba(82,0,155,0.15)",
                            }}
                          >
                            {col.label}
                          </td>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {pRows.map((pRow) => {
                        const matRow = matrixRows.find((mr) => mr.id === pRow.id);
                        return (
                          <tr key={pRow.id}>
                            <td
                              style={{
                                padding: "4px 8px",
                                fontSize: 10,
                                fontWeight: 600,
                                color: "#374151",
                                borderRight: "2px solid rgba(82,0,155,0.15)",
                                whiteSpace: "nowrap",
                                maxWidth: 130,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {pRow.rating}
                            </td>
                            {cLevels.map((col) => {
                              const cellKey = `${pRow.id}:${col.id}`;
                              const cellRating = cellRatingMap[cellKey] || "";
                              const cfg = RATING_CONFIG[cellRating];
                              const cellThemes = themesInCell[cellKey] || [];
                              return (
                                <td
                                  key={col.id}
                                  style={{
                                    padding: "6px",
                                    textAlign: "center",
                                    verticalAlign: "top",
                                    backgroundColor: cfg ? cfg.bg : "#f5f5f5",
                                    border: "1px solid rgba(0,0,0,0.07)",
                                    minWidth: 70,
                                    minHeight: 48,
                                  }}
                                >
                                  {cellRating && (
                                    <Box sx={{ mb: cellThemes.length ? 0.5 : 0 }}>
                                      <Box
                                        sx={{
                                          display: "inline-block",
                                          px: "5px",
                                          py: "1px",
                                          borderRadius: "3px",
                                          fontSize: "0.6rem",
                                          fontWeight: 800,
                                          color: cfg?.textOnDark ? "#fff" : "#212121",
                                          bgcolor: cfg?.color || "#90a4ae",
                                        }}
                                      >
                                        {cellRating}
                                      </Box>
                                    </Box>
                                  )}
                                  {cellThemes.map((th) => (
                                    <MuiTooltip
                                      key={th.themeKey}
                                      title={th.themeLabel}
                                      placement="top"
                                    >
                                      <Box
                                        sx={{
                                          display: "inline-block",
                                          maxWidth: "100%",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                          fontSize: "0.6rem",
                                          fontWeight: 600,
                                          color: "#374151",
                                          bgcolor: "rgba(0,0,0,0.06)",
                                          borderRadius: "3px",
                                          px: "4px",
                                          py: "1px",
                                          mt: "2px",
                                          cursor: "default",
                                        }}
                                      >
                                        {th.themeLabel.length > 14
                                          ? `${th.themeLabel.slice(0, 14)}…`
                                          : th.themeLabel}
                                      </Box>
                                    </MuiTooltip>
                                  ))}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Box>
              </CardContent>
            </Card>
          )}

          {/* ── Themes grouped by rating tier ── */}
          {RATING_ORDER.filter((r) => byRating[r].length > 0).map((r) => {
            const cfg = RATING_CONFIG[r];
            return (
              <Card
                key={r}
                variant="outlined"
                sx={{
                  mb: 2,
                  borderColor: cfg.border,
                  borderLeftWidth: 4,
                  borderLeftColor: cfg.color,
                  borderLeftStyle: "solid",
                }}
              >
                <CardContent sx={{ pb: "12px !important" }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                    <RatingBadge rating={r} size="large" />
                    <MDTypography variant="subtitle2" fontWeight="bold" sx={{ color: cfg.color }}>
                      {cfg.label} — {byRating[r].length} theme{byRating[r].length !== 1 ? "s" : ""}
                    </MDTypography>
                  </Box>
                  {byRating[r].map((th, i) => (
                    <Box key={th.themeKey}>
                      {i > 0 && <Divider sx={{ my: 1 }} />}
                      <Box
                        sx={{ display: "flex", alignItems: "flex-start", gap: 1, flexWrap: "wrap" }}
                      >
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <MDTypography variant="body2" fontWeight="medium">
                            {th.themeLabel}
                          </MDTypography>
                          <MDTypography variant="caption" color="text.secondary">
                            {[
                              th.llmTrend?.consequenceTypeLabel,
                              th.llmTrend?.consequenceLevelLabel,
                              th.llmTrend?.plausibilityRating,
                            ]
                              .filter(Boolean)
                              .join(" · ")}
                          </MDTypography>
                          {th.summary && (
                            <MDTypography
                              variant="caption"
                              sx={{ display: "block", color: "#555", mt: 0.25 }}
                            >
                              {th.summary.length > 160
                                ? `${th.summary.slice(0, 160)}…`
                                : th.summary}
                            </MDTypography>
                          )}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                            gap: 0.5,
                          }}
                        >
                          {th.trend7d?.direction === "increasing" && (
                            <Chip
                              size="small"
                              label={`↑ +${th.trend7d.pct}%`}
                              sx={{
                                bgcolor: "#fff3e0",
                                color: "#f57c00",
                                fontSize: "10px",
                                height: 20,
                              }}
                            />
                          )}
                          {linkedThemeKeys.has(th.themeKey) && (
                            <Chip
                              size="small"
                              label="On watch list"
                              sx={{
                                bgcolor: "#ede7f6",
                                color: "#52009b",
                                fontSize: "10px",
                                height: 20,
                              }}
                            />
                          )}
                          <MDTypography variant="caption" color="text.secondary">
                            {th.countToday || 0} alerts today
                          </MDTypography>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </CardContent>
              </Card>
            );
          })}

          {/* ── Unmonitored / unrated ── */}
          {unmonitored.length > 0 && (
            <Card variant="outlined" sx={{ mb: 2, borderColor: "rgba(82,0,155,0.15)" }}>
              <CardContent sx={{ pb: "12px !important" }}>
                <MDTypography
                  variant="subtitle2"
                  fontWeight="bold"
                  sx={{ mb: 0.5, color: "#52009b" }}
                >
                  Not yet rated — {unmonitored.length} emerging theme
                  {unmonitored.length !== 1 ? "s" : ""}
                </MDTypography>
                <MDTypography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: "block", mb: 1.5 }}
                >
                  Significant recent coverage but no matrix rating assigned yet
                </MDTypography>
                {unmonitored.slice(0, 8).map((th, i) => (
                  <Box key={th.themeKey}>
                    {i > 0 && <Divider sx={{ my: 1 }} />}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                      <MDTypography
                        variant="body2"
                        fontWeight="medium"
                        sx={{ flex: 1, minWidth: 0 }}
                      >
                        {th.themeLabel}
                      </MDTypography>
                      <Chip
                        size="small"
                        variant="outlined"
                        label={`${th.trend7d?.recent7 || 0} / 7d`}
                        sx={{ fontSize: "10px", height: 20 }}
                      />
                      {th.trend7d?.direction === "increasing" && (
                        <Chip
                          size="small"
                          label="↑ Rising"
                          sx={{
                            bgcolor: "#fff3e0",
                            color: "#f57c00",
                            fontSize: "10px",
                            height: 20,
                          }}
                        />
                      )}
                    </Box>
                    {th.summary && (
                      <MDTypography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: "block", mt: 0.25 }}
                      >
                        {th.summary.length > 160 ? `${th.summary.slice(0, 160)}…` : th.summary}
                      </MDTypography>
                    )}
                  </Box>
                ))}
              </CardContent>
            </Card>
          )}

          {t.length === 0 && (
            <MDTypography variant="body2" color="text">
              No theme data yet. Run the news ingest job to populate themes.
            </MDTypography>
          )}
        </>
      )}
    </Box>
  );
}
HorizonReactDashboard.propTypes = {
  summary: PropTypes.object,
  themes: PropTypes.arrayOf(PropTypes.object),
  activeRisks: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  error: PropTypes.string,
  onRefresh: PropTypes.func.isRequired,
  evalCriteria: PropTypes.object,
};

// ── CSV export ────────────────────────────────────────────────────────────
function csvEscape(v) {
  const s = String(v == null ? "" : v).replace(/"/g, '""');
  return `"${s}"`;
}

function exportThemesCSV(themes, todayUtc) {
  const headers = ["Theme", "Today", "Yesterday", "Trend", "Summary"];
  const rows = (themes || []).map((t) => [
    t.themeLabel,
    t.countToday,
    t.countYesterday,
    t.trendLabel,
    (t.summary || "").replace(/\n/g, " "),
  ]);
  const csv = [headers, ...rows].map((r) => r.map(csvEscape).join(",")).join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `horizon-themes${todayUtc ? `-${todayUtc}` : ""}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
// ──────────────────────────────────────────────────────────────────────────

// ── Colour palette for multi-theme line chart ──────────────────────────────
const TREND_COLORS = [
  "#52009b",
  "#e91e63",
  "#2196f3",
  "#ff9800",
  "#4caf50",
  "#00bcd4",
  "#9c27b0",
  "#f44336",
  "#3f51b5",
  "#009688",
];

function AnticipateHorizonScan() {
  const navigate = useNavigate();
  const location = useLocation();
  const { role, isSuperRiskAdmin, modules } = useCurrentUser();
  const canMonitor = role !== "VIEW";
  // UAT feedback: end users don't want the backend/debug provenance on a theme — the search-parameter
  // "boxes" and the source-trust %. That's "for us to debug." Admin/config roles still see it.
  const adminView =
    isSuperRiskAdmin ||
    String(role || "")
      .toUpperCase()
      .includes("ADMIN");
  const { execute } = useFetchWithMsal({
    scopes: [siteData?.apiScopes],
  });
  const executeRef = useRef(execute);
  executeRef.current = execute;

  const [immediateRaw, setImmediateRaw] = useState(null);
  const [aggregateRaw, setAggregateRaw] = useState(null);
  const listsFetched = useRef(false);

  const baseUrl = `${protectedResources.apiTodoList.endpoint}/anticipateHorizonScan/list`;

  const refetchHorizonLists = useCallback(() => {
    const run = executeRef.current;
    Promise.all([
      run("GET", `${baseUrl}?visibility=immediate`),
      run("GET", `${baseUrl}?visibility=aggregate_only`),
    ]).then(([imm, agg]) => {
      if (imm && imm.success === true && Array.isArray(imm.data)) {
        setImmediateRaw(imm.data);
      } else {
        setImmediateRaw([]);
      }
      if (agg && agg.success === true && Array.isArray(agg.data)) {
        setAggregateRaw(agg.data);
      } else {
        setAggregateRaw([]);
      }
    });
  }, [baseUrl]);

  useEffect(() => {
    if (listsFetched.current) return;
    listsFetched.current = true;
    refetchHorizonLists();
  }, [refetchHorizonLists]);

  const [themeOverview, setThemeOverview] = useState({
    themes: [],
    todayUtc: "",
    isOwnerFiltered: false,
    ownerCategoryIds: [],
  });
  const [overviewLoading, setOverviewLoading] = useState(true);
  const [overviewError, setOverviewError] = useState(null);
  const [selectedThemeKey, setSelectedThemeKey] = useState(null);
  // Themes selected for "Save & Monitor as Emerging Risk" — Map<themeKey, themeObj>
  const [monitorSelection, setMonitorSelection] = useState(new Map());

  // Filter + sort state
  const [searchText, setSearchText] = useState("");
  const [filterL1, setFilterL1] = useState("");
  const [filterL2, setFilterL2] = useState("");
  const [filterImportance, setFilterImportance] = useState(""); // now filters by matrixRating
  const [filterWatchlist, setFilterWatchlist] = useState(""); // "watched" | "unwatched" | ""
  const [filterCriterias, setFilterCriterias] = useState([]); // multi-select
  const [sortOrder, setSortOrder] = useState("risk_level");

  const handleToggleMonitor = useCallback((themeKey, themeObj) => {
    setMonitorSelection((prev) => {
      const next = new Map(prev);
      if (next.has(themeKey)) {
        next.delete(themeKey);
      } else {
        next.set(themeKey, themeObj);
      }
      return next;
    });
  }, []);

  // themeCategories is defined later via useMemo — use a ref so handleSaveAsEmergingRisk
  // always reads the latest value without needing it as a dep that causes re-creation.
  const themeCategoriesRef = useRef(null);

  // ID169 — advance theme(s) to the watchlist. Called from the list (uses the multi-select) and
  // from the Theme Details page (pass a single-theme array). onClick passes a SyntheticEvent, so we
  // only honour an explicit array argument and otherwise fall back to the current multi-selection.
  const handleSaveAsEmergingRisk = useCallback(
    (themesArg) => {
      const themes =
        Array.isArray(themesArg) && themesArg.length ? themesArg : [...monitorSelection.values()];
      if (themes.length === 0) return;
      const first = themes[0];
      const title = themes.map((t) => t.themeLabel || t.themeKey).join(", ");
      const description = first.whyItMatters || first.summary || "";
      const cats = themeCategoriesRef.current ? themeCategoriesRef.current[first.themeKey] : null;
      const category = cats && cats.l1Names.length > 0 ? cats.l1Names[0] : "";
      const subCategory =
        category && cats.l2ByL1[category] && cats.l2ByL1[category].length > 0
          ? cats.l2ByL1[category][0]
          : "";
      navigate("/anticipate/EmergingRisks", {
        state: {
          // ID75 — pre-populate the 1:1 linked theme (the first selected theme's key).
          prefill: {
            title,
            description,
            category,
            subCategory,
            linkedHorizonTheme: first.themeKey,
          },
        },
      });
    },
    [monitorSelection, navigate]
  );

  // ID64 — "Display Search Results" filter. null = All (no filter); array = selected param ids.
  const [displayFilterIds, setDisplayFilterIds] = useState(null);
  const displayFilterRef = useRef(null);
  displayFilterRef.current = displayFilterIds;
  const paramIdsQs = () => {
    const ids = displayFilterRef.current;
    return ids && ids.length ? `&paramIds=${encodeURIComponent(ids.join(","))}` : "";
  };

  const fetchThemeOverview = useCallback((opts = {}) => {
    setOverviewLoading(true);
    setOverviewError(null);
    const qs = `?_t=${Date.now()}${paramIdsQs()}`;
    executeRef
      .current(
        "GET",
        `${protectedResources.apiTodoList.endpoint}/anticipateHorizonScan/theme-overview${qs}`
      )
      .then((res) => {
        if (res && res.success === true && res.data && Array.isArray(res.data.themes)) {
          setThemeOverview(res.data);
        } else {
          setThemeOverview({ themes: [], todayUtc: "" });
          setOverviewError(res?.message || "Could not load theme overview.");
        }
      })
      .catch(() => {
        setOverviewError("Request failed.");
        setThemeOverview({ themes: [], todayUtc: "" });
      })
      .finally(() => setOverviewLoading(false));
  }, []);

  const [mainTab, setMainTab] = useState(0);

  // ─────────────────────────────────────────────────────────────────────────

  const [classifyBackfillLoading, setClassifyBackfillLoading] = useState(false);
  const [classifyBackfillMsg, setClassifyBackfillMsg] = useState(null);
  const handleClassifyBackfill = useCallback((types) => {
    setClassifyBackfillLoading(true);
    setClassifyBackfillMsg(null);
    executeRef
      .current(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/anticipateHorizonScan/backfill-classifications`,
        { types, batchSize: 200 }
      )
      .then((res) => {
        if (res?.success && res.data) {
          const parts = Object.entries(res.data)
            .map(([k, v]) => `${k}: ${v.updated}/${v.processed} updated`)
            .join(" · ");
          setClassifyBackfillMsg({
            text: `Batch complete — ${parts}. Run again if counts > 0.`,
            severity: "success",
          });
        } else {
          setClassifyBackfillMsg({ text: res?.message || "Backfill failed.", severity: "error" });
        }
      })
      .catch(() => setClassifyBackfillMsg({ text: "Backfill request failed.", severity: "error" }))
      .finally(() => setClassifyBackfillLoading(false));
  }, []);

  // Consolidate over-split EVENT tags: club facets of the same real-world incident (e.g. the ~30
  // Sydney near-miss slugs spread across themes) into one event card. The cross-theme pass makes many
  // sequential LLM calls (minutes), so the endpoint is fire-and-forget — it starts the job and returns
  // immediately; reload a few minutes later to see the merged cards. (Also runs nightly automatically.)
  const [eventConsolLoading, setEventConsolLoading] = useState(false);
  const handleConsolidateEvents = useCallback(() => {
    setEventConsolLoading(true);
    setClassifyBackfillMsg(null);
    executeRef
      .current(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/anticipateHorizonScan/consolidate-events`,
        {}
      )
      .then((res) => {
        setClassifyBackfillMsg({
          text: res?.success
            ? res.message || "Event consolidation started — reload in a few minutes."
            : res?.message || "Could not start event consolidation.",
          severity: res?.success ? "info" : "error",
        });
      })
      .catch(() =>
        setClassifyBackfillMsg({ text: "Consolidate Events request failed.", severity: "error" })
      )
      .finally(() => setEventConsolLoading(false));
  }, []);

  // Multi-lens top-down (V2): generate emerging themes across Global + each geography + each sector +
  // organisation. It makes ~1 LLM call per lens (minutes), so the endpoint runs fire-and-forget.
  const [topDownLoading, setTopDownLoading] = useState(false);
  const handleTopDownMultiLens = useCallback(() => {
    setTopDownLoading(true);
    setClassifyBackfillMsg(null);
    executeRef
      .current(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/anticipateHorizonScan/run-topdown-themes`,
        { multiLens: true, async: true }
      )
      .then((res) => {
        setClassifyBackfillMsg({
          text: res?.success
            ? res.message || "Top-down generation started — reload in a few minutes."
            : res?.message || "Could not start top-down generation.",
          severity: res?.success ? "info" : "error",
        });
      })
      .catch(() => setClassifyBackfillMsg({ text: "Top-down request failed.", severity: "error" }))
      .finally(() => setTopDownLoading(false));
  }, []);

  // ── Re-categorise + rebuild themes (test new categorisation over historical alerts) ──
  const [recatLoading, setRecatLoading] = useState(false);
  const [recatMsg, setRecatMsg] = useState(null);
  const handleRecategorize = useCallback((opts = {}) => {
    setRecatLoading(true);
    setRecatMsg(null);
    executeRef
      .current(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/anticipateHorizonScan/recategorize-themes`,
        opts
      )
      .then((res) => {
        if (res?.success) {
          setRecatMsg({ text: res.message, severity: "success" });
        } else {
          setRecatMsg({ text: res?.message || "Recategorisation failed.", severity: "error" });
        }
      })
      .catch(() => setRecatMsg({ text: "Recategorisation request failed.", severity: "error" }))
      .finally(() => setRecatLoading(false));
  }, []);
  // ID124 — re-assign each alert's L1 + single L2 risk category over historical alerts.
  const handleRecategorizeCategories = useCallback(
    (opts = {}) => {
      setRecatLoading(true);
      setRecatMsg(null);
      executeRef
        .current(
          "POST",
          `${protectedResources.apiTodoList.endpoint}/anticipateHorizonScan/recategorize-categories`,
          opts
        )
        .then((res) => {
          if (res?.success) {
            setRecatMsg({ text: res.message, severity: "success" });
            if (res.data && res.data.remaining === 0) fetchThemeOverview();
          } else {
            setRecatMsg({
              text: res?.message || "Category recategorisation failed.",
              severity: "error",
            });
          }
        })
        .catch(() =>
          setRecatMsg({ text: "Category recategorisation request failed.", severity: "error" })
        )
        .finally(() => setRecatLoading(false));
    },
    [fetchThemeOverview]
  );
  // ID137 — single "delete all + recreate" action: rebuilds bottom-up themes from the current news
  // alerts, then regenerates the top-down (CRO) themes and merges them in. Replaces the separate
  // "Rebuild Themes" and "Refresh Top-Down Themes" buttons.
  const handleRebuildAll = useCallback(async () => {
    // eslint-disable-next-line no-alert
    const ok = window.confirm(
      "This DELETES all existing themes and recreates them:\n\n" +
        "1) Bottom-up — rebuilds themes from the current news alerts (alerts are kept)\n" +
        "2) Top-down — regenerates the CRO emerging risks and merges them in\n\n" +
        "Summaries and ratings regenerate in the background. Continue?"
    );
    if (!ok) return;
    setRecatLoading(true);
    setRecatMsg(null);
    const base = protectedResources.apiTodoList.endpoint;
    try {
      const rb = await executeRef.current(
        "POST",
        `${base}/anticipateHorizonScan/rebuild-themes`,
        {}
      );
      if (!rb?.success) {
        setRecatMsg({ text: rb?.message || "Rebuild failed.", severity: "error" });
        return;
      }
      const td = await executeRef.current(
        "POST",
        `${base}/anticipateHorizonScan/run-topdown-themes`,
        {}
      );
      if (td?.success) {
        setRecatMsg({ text: `${rb.message} ${td.message}`, severity: "success" });
      } else {
        setRecatMsg({
          text: `Themes rebuilt from news. Top-down step failed: ${td?.message || "error"}`,
          severity: "warning",
        });
      }
      refetchHorizonLists();
    } catch {
      setRecatMsg({ text: "Rebuild request failed.", severity: "error" });
    } finally {
      setRecatLoading(false);
    }
  }, [refetchHorizonLists]);

  const handleConsolidateThemes = useCallback(() => {
    // eslint-disable-next-line no-alert
    const ok = window.confirm(
      "AI will merge duplicate/synonym theme labels into canonical ones and remap the affected " +
        "alerts. Run 'Rebuild Themes' afterwards to refresh the list. Continue?"
    );
    if (!ok) return;
    setRecatLoading(true);
    setRecatMsg(null);
    executeRef
      .current(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/anticipateHorizonScan/consolidate-themes`,
        {}
      )
      .then((res) => {
        if (res?.success) {
          setRecatMsg({ text: res.message, severity: "success" });
        } else {
          setRecatMsg({ text: res?.message || "Consolidation failed.", severity: "error" });
        }
      })
      .catch(() => setRecatMsg({ text: "Consolidation request failed.", severity: "error" }))
      .finally(() => setRecatLoading(false));
  }, []);

  const [summaryRefreshLoading, setSummaryRefreshLoading] = useState(false);
  const [summaryRefreshMsg, setSummaryRefreshMsg] = useState(null);
  const handleRefreshSummaries = useCallback(
    (themeKey) => {
      setSummaryRefreshLoading(true);
      setSummaryRefreshMsg(null);
      const body = themeKey ? { theme: themeKey } : {};
      executeRef
        .current(
          "POST",
          `${protectedResources.apiTodoList.endpoint}/anticipateHorizonScan/refresh-theme-summaries`,
          body
        )
        .then((res) => {
          if (res && res.success) {
            const d = res.data || {};
            setSummaryRefreshMsg(`Summaries refreshed: ${d.refreshed || 0} updated.`);
            fetchThemeOverview({});
          } else {
            setSummaryRefreshMsg(res?.message || "Refresh failed.");
          }
        })
        .catch(() => setSummaryRefreshMsg("Refresh failed."))
        .finally(() => setSummaryRefreshLoading(false));
    },
    [fetchThemeOverview]
  );

  const [dashRollups, setDashRollups] = useState([]);
  const [dashSummary, setDashSummary] = useState(null);
  const [dashThemes, setDashThemes] = useState([]);
  const [dashRisks, setDashRisks] = useState([]);
  const [dashLoading, setDashLoading] = useState(false);
  const [dashError, setDashError] = useState(null);
  const [dashEvalCriteria, setDashEvalCriteria] = useState(null);

  const fetchHorizonDashboard = useCallback(() => {
    setDashLoading(true);
    setDashError(null);
    const ep = protectedResources.apiTodoList.endpoint;
    Promise.all([
      executeRef.current("GET", `${ep}/anticipateHorizonScan/rollups`),
      executeRef.current(
        "GET",
        `${ep}/anticipateHorizonScan/theme-overview?_t=${Date.now()}${paramIdsQs()}`
      ),
      executeRef.current("GET", `${ep}/emergingRisk/list`),
      executeRef.current("GET", `${ep}/evaluation-criteria/config`),
    ])
      .then(([rollupRes, themeRes, riskRes, criteriaRes]) => {
        const payload =
          rollupRes?.data && typeof rollupRes.data === "object" && !Array.isArray(rollupRes.data)
            ? rollupRes.data
            : null;
        if (rollupRes?.success === true && payload) {
          setDashRollups(Array.isArray(payload.rollups) ? payload.rollups : []);
          setDashSummary(payload.summary || null);
        } else {
          setDashError(rollupRes?.message || "Could not load dashboard.");
        }
        setDashThemes(Array.isArray(themeRes?.data?.themes) ? themeRes.data.themes : []);
        setDashRisks(
          Array.isArray(riskRes?.data) ? riskRes.data.filter((r) => r.status === "active") : []
        );
        setDashEvalCriteria(criteriaRes?.data ?? criteriaRes ?? null);
      })
      .catch(() => setDashError("Request failed."))
      .finally(() => setDashLoading(false));
  }, []);

  useEffect(() => {
    if (mainTab !== 0) return;
    fetchHorizonDashboard();
  }, [mainTab, fetchHorizonDashboard]);

  const listsReady = immediateRaw != null && aggregateRaw != null;

  useEffect(() => {
    if (!listsReady || mainTab !== 1) return;
    fetchThemeOverview({});
  }, [listsReady, mainTab, fetchThemeOverview]);

  // ID64 — re-apply the Display Search Results filter to the active view when it changes.
  const filterFirstRun = useRef(true);
  useEffect(() => {
    if (filterFirstRun.current) {
      filterFirstRun.current = false;
      return;
    }
    if (mainTab === 0) fetchHorizonDashboard();
    else if (mainTab === 1) fetchThemeOverview({});
  }, [displayFilterIds, mainTab, fetchHorizonDashboard, fetchThemeOverview]);

  const combinedRaw = useMemo(
    () => mergeHorizonRawLists(immediateRaw, aggregateRaw),
    [immediateRaw, aggregateRaw]
  );

  // Map: themeKey → articles (for filter cross-reference)
  const themeArticles = useMemo(() => {
    const map = new Map();
    (combinedRaw || []).forEach((item) => {
      // Index by themeTag (for themeTag-based themes)
      const tKey = (item.themeTag || "").trim() || "__uncategorized__";
      if (!map.has(tKey)) map.set(tKey, []);
      map.get(tKey).push(item);
      // Also index by eventTag (for event-tagged themes)
      const eKey = (item.eventTag || "").trim();
      if (eKey) {
        if (!map.has(eKey)) map.set(eKey, []);
        map.get(eKey).push(item);
      }
    });
    return map;
  }, [combinedRaw]);

  // Per-theme category summary — single best-fit L1 + L2 (most frequent pair across articles)
  const themeCategories = useMemo(() => {
    const result = {};
    // First pass: build per-theme from article data
    themeArticles.forEach((articles, themeKey) => {
      const pairCount = {};
      articles.forEach((a) => {
        const l1 = (a.primaryL1CategoryName || "").trim();
        const l2 = (a.primaryL2CategoryName || "").trim();
        if (!l1) return;
        const key = l2 ? `${l1}||${l2}` : `${l1}||`;
        pairCount[key] = (pairCount[key] || 0) + 1;
      });
      if (Object.keys(pairCount).length === 0) {
        result[themeKey] = { l1Names: [], l2ByL1: {} };
        return;
      }
      // Pick single most-frequent pair
      const best = Object.entries(pairCount).sort((a, b) => b[1] - a[1])[0][0];
      const [bestL1, bestL2] = best.split("||");
      const l2ByL1 = {};
      if (bestL2) l2ByL1[bestL1] = [bestL2];
      result[themeKey] = { l1Names: [bestL1], l2ByL1 };
    });
    // Second pass: for event-tagged themes (from API), use bestFitL2 if available
    (themeOverview.themes || []).forEach((t) => {
      if (t.isEventTagTheme && t.bestFitL2 && !result[t.themeKey]?.l1Names?.length) {
        result[t.themeKey] = { l1Names: [], l2ByL1: {}, bestFitL2: t.bestFitL2 };
      } else if (t.isEventTagTheme && t.bestFitL2) {
        result[t.themeKey] = { ...result[t.themeKey], bestFitL2: t.bestFitL2 };
      }
    });
    return result;
  }, [themeArticles, themeOverview.themes]);
  // Keep ref in sync so handleSaveAsEmergingRisk always reads latest without stale closure
  themeCategoriesRef.current = themeCategories;

  // L1 options: unique L1 categories from all articles
  const l1Options = useMemo(() => {
    const seen = new Set();
    const out = [];
    (combinedRaw || []).forEach((item) => {
      const name = (item.primaryL1CategoryName || "").trim();
      if (name && !seen.has(name)) {
        seen.add(name);
        out.push({ id: item.primaryL1CategoryId || name, name });
      }
    });
    return out.sort((a, b) => a.name.localeCompare(b.name));
  }, [combinedRaw]);

  // L2 options: subcategories for selected L1
  const l2Options = useMemo(() => {
    if (!filterL1) return [];
    const seen = new Set();
    const out = [];
    (combinedRaw || []).forEach((item) => {
      if ((item.primaryL1CategoryName || "").trim() !== filterL1) return;
      const name = (item.primaryL2CategoryName || "").trim();
      if (name && !seen.has(name)) {
        seen.add(name);
        out.push({ id: item.primaryL2CategoryId || name, name });
      }
    });
    return out.sort((a, b) => a.name.localeCompare(b.name));
  }, [combinedRaw, filterL1]);

  // Criteria options: unique criteriaLabels from all theme relationshipTags (Filter 3)
  const criteriaOptions = useMemo(() => {
    const seen = new Set();
    const out = [];
    (themeOverview.themes || []).forEach((t) => {
      (t.relationshipTags || []).forEach((tag) => {
        const label = (tag.criteriaLabel || "").trim();
        if (label && !seen.has(label)) {
          seen.add(label);
          out.push(label);
        }
      });
    });
    return out.sort((a, b) => a.localeCompare(b));
  }, [themeOverview.themes]);

  // Matrix rating sort order: E=0 (highest risk) … VL=4, unrated=5
  const MATRIX_RATING_ORDER = { E: 0, H: 1, M: 2, L: 3, VL: 4 };

  // Themes linked to active risks (for watchlist filter + badge)
  const linkedThemeKeySet = useMemo(
    () => new Set((dashRisks || []).map((r) => r.linkedHorizonTheme).filter(Boolean)),
    [dashRisks]
  );

  // ID154 — map each linked theme → its watchlist risk {id,title}, and a resolver that also
  // falls back to the parent theme tag (a child cluster may inherit the parent's link).
  const linkedRiskByTheme = useMemo(() => {
    const m = new Map();
    (dashRisks || []).forEach((r) => {
      const k = r.linkedHorizonTheme;
      if (k && !m.has(k)) {
        m.set(k, {
          id: String(r._id || r.id || ""),
          title: r.Title || r.title || "Watchlist risk",
        });
      }
    });
    return m;
  }, [dashRisks]);
  const linkedRiskFor = useCallback(
    (t) =>
      t
        ? linkedRiskByTheme.get(t.themeKey) ||
          (t.parentThemeTag ? linkedRiskByTheme.get(t.parentThemeTag) : null) ||
          null
        : null,
    [linkedRiskByTheme]
  );
  // Open a watchlist risk's details page (ID154 — flag/link from a Horizon Scan theme).
  const openWatchlistRisk = useCallback(
    (riskId) => {
      if (!riskId) return;
      navigate("/anticipate/EmergingRisks", { state: { openRiskId: riskId } });
    },
    [navigate]
  );
  // Open a theme's full details — switch to the Emerging Themes tab and select it (same as the
  // ?theme= deep-link). Used by the "View full theme details" link on the dashboard's detail card.
  const openThemeDetail = useCallback((themeKey) => {
    if (!themeKey) return;
    setMainTab(1);
    setSelectedThemeKey(themeKey);
  }, []);

  // Filter + sort theme overview list
  // Per-themeTag relevance index: which tags have any article, and which have any RELEVANT article
  // (null score or >= threshold counts as relevant, so unscored themes are never hidden). Used to
  // drop themes whose alerts are all low-relevance.
  const themeRelevance = useMemo(() => {
    const nr = (s) =>
      String(s || "")
        .trim()
        .toLowerCase();
    const withArticles = new Set();
    const withRelevant = new Set();
    (combinedRaw || []).forEach((a) => {
      const k = nr(a.themeTag);
      if (!k) return;
      withArticles.add(k);
      if (a.relevanceScore == null || a.relevanceScore >= RELEVANCE_HIDE_BELOW) withRelevant.add(k);
    });
    return { withArticles, withRelevant };
  }, [combinedRaw]);

  const filteredThemes = useMemo(() => {
    const PLACEHOLDER_LABELS = new Set(["unknown", "uncategorized", "none", "n/a", "tbd", "tbc"]);
    let list = (themeOverview.themes || []).filter((t) => {
      const label = (t.themeLabel || "").trim().toLowerCase();
      return t.themeKey !== "__uncategorized__" && label && !PLACEHOLDER_LABELS.has(label);
    });
    if (searchText.trim()) {
      const q = searchText.toLowerCase();
      list = list.filter((t) => (t.themeLabel || "").toLowerCase().includes(q));
    }
    // Filter by matrix risk rating (replaces old H/M/L priorityBand filter)
    if (filterImportance) {
      list = list.filter((t) => (t.llmTrend?.matrixRating || "") === filterImportance);
    }
    // Filter by watchlist status
    if (filterWatchlist === "watched") {
      list = list.filter((t) => linkedThemeKeySet.has(t.themeKey));
    } else if (filterWatchlist === "unwatched") {
      list = list.filter((t) => !linkedThemeKeySet.has(t.themeKey));
    }
    // Filter by L1/L2 category
    if (filterL1 || filterL2) {
      list = list.filter((t) => {
        const articles = themeArticles.get(t.themeKey) || [];
        if (articles.length > 0) {
          return articles.some((a) => {
            if (filterL1 && (a.primaryL1CategoryName || "").trim() !== filterL1) return false;
            if (filterL2 && (a.primaryL2CategoryName || "").trim() !== filterL2) return false;
            return true;
          });
        }
        // ID137 — top-down themes have no articles; match on their AI-assigned category.
        if (filterL1 && (t.llmTrend?.l1CategoryName || "").trim() !== filterL1) return false;
        if (filterL2 && (t.llmTrend?.l2CategoryName || "").trim() !== filterL2) return false;
        return true;
      });
    }
    // Filter: Specific Criteria
    if (filterCriterias.length > 0) {
      list = list.filter((t) =>
        (t.relationshipTags || []).some((tag) => filterCriterias.includes(tag.criteriaLabel))
      );
    }
    // Hide themes whose alerts are ALL low-relevance (off the business's geography/industry) — a
    // theme that has articles but not one passing the relevance bar is noise, so don't surface it.
    // Themes with no fetched articles (e.g. top-down) are left to the other rules.
    {
      const nr = (s) =>
        String(s || "")
          .trim()
          .toLowerCase();
      list = list.filter((t) => {
        const keys = [
          ...(t.clusterMembers || []),
          t.parentThemeTag,
          t.themeKey,
          t.themeLabel,
          t.llmTrend?.displayName,
        ]
          .filter(Boolean)
          .map(nr);
        const hasArticles = keys.some((k) => themeRelevance.withArticles.has(k));
        if (!hasArticles) return true;
        return keys.some((k) => themeRelevance.withRelevant.has(k));
      });
    }
    // Sort
    list = [...list];
    if (sortOrder === "risk_level") {
      list.sort((a, b) => {
        const ra = MATRIX_RATING_ORDER[a.llmTrend?.matrixRating] ?? 5;
        const rb = MATRIX_RATING_ORDER[b.llmTrend?.matrixRating] ?? 5;
        return ra !== rb ? ra - rb : (b.countToday || 0) - (a.countToday || 0);
      });
    } else if (sortOrder === "name_asc") {
      // ID52 — sort by the name the user actually SEES (the display name), not the raw themeLabel,
      // otherwise the order looks non-alphabetical. Case-insensitive + natural number ordering.
      const nameOf = (t) => (t.llmTrend?.displayName || t.themeLabel || t.themeKey || "").trim();
      list.sort((a, b) =>
        nameOf(a).localeCompare(nameOf(b), undefined, { sensitivity: "base", numeric: true })
      );
    } else if (sortOrder === "date_desc") {
      list.sort((a, b) => {
        const da = a.latestIngestedAt ? new Date(a.latestIngestedAt).getTime() : 0;
        const db = b.latestIngestedAt ? new Date(b.latestIngestedAt).getTime() : 0;
        return db - da;
      });
    } else if (sortOrder === "date_asc") {
      list.sort((a, b) => {
        const da = a.latestIngestedAt ? new Date(a.latestIngestedAt).getTime() : 0;
        const db = b.latestIngestedAt ? new Date(b.latestIngestedAt).getTime() : 0;
        return da - db;
      });
    } else if (sortOrder === "trend") {
      // ID62 — worsening → stable → improving; ties broken by today's alert volume.
      const TREND_DIR_ORDER = { worsening: 0, stable: 1, improving: 2 };
      list.sort((a, b) => {
        const ta = TREND_DIR_ORDER[a.llmTrend?.direction] ?? 1;
        const tb = TREND_DIR_ORDER[b.llmTrend?.direction] ?? 1;
        return ta !== tb ? ta - tb : (b.countToday || 0) - (a.countToday || 0);
      });
    }
    return list;
  }, [
    themeOverview.themes,
    searchText,
    filterL1,
    filterL2,
    filterImportance,
    filterWatchlist,
    filterCriterias,
    sortOrder,
    themeArticles,
    themeRelevance,
    linkedThemeKeySet,
  ]);

  // "What's changed since last visit" for the Themes tab. Snapshot the full overview
  // list (not the filtered subset) so the baseline is independent of active filters.
  const {
    showChange: showThemeChange,
    setShowChange: setShowThemeChange,
    changeFor: themeChangeFor,
    summary: themeChangeSummary,
  } = useThemeChanges("horizonThemesChanges", themeOverview.themes, themeOverview.todayUtc);

  // Selected theme object — exposed at component level so useEffects can access it
  const selectedThemeObj = useMemo(
    () => (themeOverview.themes || []).find((t) => t.themeKey === selectedThemeKey) || null,
    [selectedThemeKey, themeOverview.themes]
  );

  // Screen-aware Risk Advisor — publish the visible emerging themes + the focused theme.
  const { setScreenContext } = useScreenContext();
  useEffect(() => {
    const themes = (themeOverview.themes || []).slice(0, 25).map((t) => ({
      theme: t.llmTrend?.displayName || t.themeLabel || t.themeKey,
      rating: t.llmTrend?.matrixRating || "",
      trend: t.llmTrend?.direction || t.trend7d?.direction || "",
      alertsToday: t.countToday,
    }));
    setScreenContext({
      route: location.pathname,
      screenName: "Horizon Scan",
      data: {
        themeCount: (themeOverview.themes || []).length,
        focusedTheme: selectedThemeObj
          ? selectedThemeObj.llmTrend?.displayName ||
            selectedThemeObj.themeLabel ||
            selectedThemeObj.themeKey
          : null,
        themes,
      },
    });
  }, [themeOverview.themes, selectedThemeObj, location.pathname, setScreenContext]);

  // Articles for selected theme — expands cluster members so merged themes show all their articles
  const detailRaw = useMemo(() => {
    if (selectedThemeKey == null) return [];
    const t = selectedThemeObj;
    const norm = (s) =>
      String(s || "")
        .trim()
        .toLowerCase();
    const seen = new Set();
    const combined = [];

    // Event sub-topic card (isEventTagTheme) is defined solely by its eventTag: show ONLY articles
    // carrying that eventTag — pulling in the parent theme would flood it (e.g. the "Sydney Airport
    // Near Miss" event showing all 200+ "Aviation Workforce" staffing alerts). Matched via the
    // eventTag index in themeArticles.
    if (t?.isEventTagTheme) {
      const members = [t?.themeKey, selectedThemeKey].filter(Boolean);
      for (const memberKey of [...new Set(members)]) {
        for (const article of themeArticles.get(memberKey) || []) {
          const uid = String(article._id || article.id || article.url || "");
          if (uid && seen.has(uid)) continue;
          if (uid) seen.add(uid);
          combined.push(article);
        }
      }
      return combined;
    }

    // Regular theme: include EVERY article whose themeTag belongs to this theme — matched against
    // ALL of the theme's identifiers (cluster members, parent tag, key, label, display name),
    // normalised. Robust to display-vs-stored-tag differences (e.g. "…Impact" stored vs "…Challenges"
    // shown) and to an article whose themeTag isn't listed among the theme's cluster members — which
    // is why some well-evidenced themes previously showed "No news stream".
    const keys = new Set(
      [
        ...(t?.clusterMembers || []),
        t?.parentThemeTag,
        t?.themeKey,
        selectedThemeKey,
        t?.themeLabel,
        t?.llmTrend?.displayName,
      ]
        .filter(Boolean)
        .map(norm)
    );
    for (const article of combinedRaw || []) {
      if (!keys.has(norm(article.themeTag))) continue;
      const uid = String(article._id || article.id || article.url || "");
      if (uid && seen.has(uid)) continue;
      if (uid) seen.add(uid);
      combined.push(article);
    }
    return combined;
  }, [selectedThemeKey, selectedThemeObj, themeArticles, combinedRaw]);

  // Per-theme trend chart state
  const [themeTrend, setThemeTrend] = useState(null);
  const [themeTrendLoading, setThemeTrendLoading] = useState(false);
  const [themeTrendDays, setThemeTrendDays] = useState(90);
  // ID54 — clicking a chart point filters the alerts table to that day.
  const [selectedTrendDate, setSelectedTrendDate] = useState(null);

  useEffect(() => {
    setSelectedTrendDate(null);
  }, [selectedThemeKey]);

  // ID58 — a theme alert links to ?theme=<tag>; open that theme's detail page directly.
  useEffect(() => {
    const params = new URLSearchParams(location.search || "");
    const themeParam = (params.get("theme") || "").trim();
    if (themeParam) {
      setMainTab(1);
      setSelectedThemeKey(themeParam);
    }
  }, [location.search]);

  useEffect(() => {
    if (!selectedThemeKey) {
      setThemeTrend(null);
      return;
    }
    setThemeTrendLoading(true);
    setThemeTrend(null);
    executeRef
      .current(
        "GET",
        `${
          protectedResources.apiTodoList.endpoint
        }/anticipateHorizonScan/theme-trends?days=${themeTrendDays}&theme=${encodeURIComponent(
          selectedThemeObj?.parentThemeTag || selectedThemeKey
        )}`
      )
      .then((res) => {
        if (res && res.success === true && res.data) setThemeTrend(res.data);
      })
      .finally(() => setThemeTrendLoading(false));
  }, [selectedThemeKey, themeTrendDays]);

  const [ignoredDomains, setIgnoredDomains] = useState(new Set());
  const [ignoreSnack, setIgnoreSnack] = useState(null); // { message, severity }

  const handleIgnoreDomain = useCallback((domain) => {
    executeRef
      .current(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/anticipateHorizonScan/ignore-domains/add`,
        { domain }
      )
      .then((res) => {
        if (res && res.success) {
          setIgnoredDomains((prev) => new Set([...prev, domain]));
          setIgnoreSnack({
            message: `"${domain}" added to ignored domains. Future ingest will skip it.`,
            severity: "success",
          });
        } else {
          const msg = res?.message || "Failed to add domain.";
          setIgnoreSnack({ message: msg, severity: "error" });
        }
      });
  }, []);

  const filteredDetailRaw = useMemo(
    () => detailRaw.filter((a) => !ignoredDomains.has(a.sourceDomain)),
    [detailRaw, ignoredDomains]
  );

  // When a chart point is clicked, narrow the alerts table to that day (ID54).
  const dateFilteredDetailRaw = useMemo(() => {
    if (!selectedTrendDate) return filteredDetailRaw;
    return filteredDetailRaw.filter((a) => {
      const day = a.ingestedAt ? new Date(a.ingestedAt).toISOString().slice(0, 10) : null;
      return day === selectedTrendDate;
    });
  }, [filteredDetailRaw, selectedTrendDate]);

  // ID149 — News Stream sorting. Default = newest first (by date); user can switch to risk level
  // (consequence level, highest first). Risk level falls back to date for ties / unclassified.
  const [newsSort, setNewsSort] = useState("date"); // "date" | "risk" | "relevance"
  // P2-02 — hide off-target (low-relevance) alerts by default so the material items surface.
  const [hideLowRelevance, setHideLowRelevance] = useState(true);
  const relevanceFilteredDetailRaw = useMemo(() => {
    if (!hideLowRelevance) return dateFilteredDetailRaw;
    // Keep unscored (null) — only hide alerts explicitly scored below the threshold.
    return dateFilteredDetailRaw.filter(
      (a) => a.relevanceScore == null || a.relevanceScore >= RELEVANCE_HIDE_BELOW
    );
  }, [dateFilteredDetailRaw, hideLowRelevance]);
  const hiddenLowRelevanceCount = dateFilteredDetailRaw.filter(
    (a) => a.relevanceScore != null && a.relevanceScore < RELEVANCE_HIDE_BELOW
  ).length;
  const sortedDetailRaw = useMemo(() => {
    const dateOf = (a) => new Date(a.ingestedAt || a.date || 0).getTime();
    const levelOf = (a) => parseInt((a.consequenceLevelLabel || "").match(/\d+/)?.[0] || "0", 10);
    const relOf = (a) => (a.relevanceScore == null ? -1 : a.relevanceScore);
    const arr = [...relevanceFilteredDetailRaw];
    if (newsSort === "risk") {
      arr.sort((a, b) => levelOf(b) - levelOf(a) || dateOf(b) - dateOf(a));
    } else if (newsSort === "relevance") {
      arr.sort((a, b) => relOf(b) - relOf(a) || dateOf(b) - dateOf(a));
    } else {
      arr.sort((a, b) => dateOf(b) - dateOf(a));
    }
    return arr;
  }, [relevanceFilteredDetailRaw, newsSort]);

  const detailTableRows = useMemo(
    () => mapRawToTableRows(sortedDetailRaw, handleIgnoreDomain),
    [sortedDetailRaw, handleIgnoreDomain]
  );

  const detailColumns = [
    {
      id: "title",
      accessorKey: "title",
      header: "News Stream",
      size: 140,
    },
  ];

  let detailTabBody;
  if (!listsReady) {
    detailTabBody = (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress sx={{ color: "#52009b" }} />
      </Box>
    );
  } else if (selectedThemeKey == null) {
    // Themes list view with filter bar
    const totalThemes = (themeOverview.themes || []).length;

    detailTabBody = (
      <>
        {/* Filter bar — caption label above each control (consistent with the Dashboard filters). */}
        <Box sx={{ display: "flex", gap: 1.5, mb: 1.5, flexWrap: "wrap", alignItems: "flex-end" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 0.4,
              flex: "1 1 160px",
              minWidth: 140,
            }}
          >
            <MDTypography sx={FILTER_LABEL_SX}>Search</MDTypography>
            <TextField
              size="small"
              placeholder="Search themes..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              sx={FILTER_INPUT_SX}
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.4 }}>
            <MDTypography sx={FILTER_LABEL_SX}>Category</MDTypography>
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <Select
                value={filterL1}
                displayEmpty
                onChange={(e) => {
                  setFilterL1(e.target.value);
                  setFilterL2("");
                }}
                sx={FILTER_INPUT_SX}
              >
                <MenuItem value="">All categories</MenuItem>
                {l1Options.map((opt) => (
                  <MenuItem key={opt.id} value={opt.name}>
                    {opt.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.4 }}>
            <MDTypography sx={FILTER_LABEL_SX}>Sub-category</MDTypography>
            <FormControl size="small" sx={{ minWidth: 180 }} disabled={!filterL1}>
              <Select
                value={filterL2}
                displayEmpty
                onChange={(e) => setFilterL2(e.target.value)}
                sx={FILTER_INPUT_SX}
              >
                <MenuItem value="">All</MenuItem>
                {l2Options.map((opt) => (
                  <MenuItem key={opt.id} value={opt.name}>
                    {opt.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.4 }}>
            <MDTypography sx={FILTER_LABEL_SX}>Risk level</MDTypography>
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <Select
                value={filterImportance}
                displayEmpty
                onChange={(e) => setFilterImportance(e.target.value)}
                sx={FILTER_INPUT_SX}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="E">E — Extreme</MenuItem>
                <MenuItem value="H">H — High</MenuItem>
                <MenuItem value="M">M — Medium</MenuItem>
                <MenuItem value="L">L — Low</MenuItem>
                <MenuItem value="VL">VL — Very Low</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.4 }}>
            <MDTypography sx={FILTER_LABEL_SX}>Watchlist</MDTypography>
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <Select
                value={filterWatchlist}
                displayEmpty
                onChange={(e) => setFilterWatchlist(e.target.value)}
                sx={FILTER_INPUT_SX}
              >
                <MenuItem value="">All themes</MenuItem>
                <MenuItem value="watched">⚑ On watchlist</MenuItem>
                <MenuItem value="unwatched">Not on watchlist</MenuItem>
              </Select>
            </FormControl>
          </Box>
          {/* ID125 — "Driver Type" filter removed along with the Type field. */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.4 }}>
            <MDTypography sx={FILTER_LABEL_SX}>Specific criteria</MDTypography>
            <Autocomplete
              multiple
              size="small"
              options={criteriaOptions}
              value={filterCriterias}
              onChange={(_, val) => setFilterCriterias(val)}
              disableCloseOnSelect
              disabled={criteriaOptions.length === 0}
              renderInput={(params) => (
                <TextField {...params} placeholder={filterCriterias.length === 0 ? "All" : ""} />
              )}
              sx={{ minWidth: 200, bgcolor: "#fff" }}
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.4 }}>
            <MDTypography sx={FILTER_LABEL_SX}>Sort by</MDTypography>
            <FormControl size="small" sx={{ minWidth: 160 }}>
              <Select
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
                sx={FILTER_INPUT_SX}
              >
                <MenuItem value="risk_level">Risk level (E→VL)</MenuItem>
                <MenuItem value="name_asc">Theme name (A→Z)</MenuItem>
                <MenuItem value="date_desc">Updated (newest first)</MenuItem>
                <MenuItem value="date_asc">Updated (oldest first)</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
        {summaryRefreshMsg && (
          <Alert
            severity={summaryRefreshMsg.startsWith("Summaries refreshed") ? "success" : "error"}
            onClose={() => setSummaryRefreshMsg(null)}
            sx={{ mb: 1, fontSize: "0.82rem" }}
          >
            {summaryRefreshMsg}
          </Alert>
        )}
        {classifyBackfillMsg && (
          <Alert
            severity={classifyBackfillMsg.severity}
            onClose={() => setClassifyBackfillMsg(null)}
            sx={{ mb: 1, fontSize: "0.82rem" }}
          >
            {classifyBackfillMsg.text}
          </Alert>
        )}
        {recatMsg && (
          <Alert
            severity={recatMsg.severity}
            onClose={() => setRecatMsg(null)}
            sx={{ mb: 1, fontSize: "0.82rem" }}
          >
            {recatMsg.text}
          </Alert>
        )}

        {/* Action buttons — second line. Export CSV is available to everyone; the maintenance
            actions are SUPER_RISK_ADMIN only. */}
        <Box sx={{ display: "flex", gap: 1.5, mb: 2, flexWrap: "wrap", alignItems: "center" }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => exportThemesCSV(filteredThemes, themeOverview.todayUtc)}
            sx={{ borderColor: "#52009b", color: "#52009b", whiteSpace: "nowrap" }}
          >
            Export CSV
          </Button>
          {isSuperRiskAdmin && (
            <MuiTooltip title="Regenerate LLM summaries and 'Why it matters' for all themes (uses recent articles — no new ingest required)">
              <span>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={summaryRefreshLoading}
                  onClick={() => handleRefreshSummaries()}
                  startIcon={
                    summaryRefreshLoading ? (
                      <CircularProgress size={14} sx={{ color: "#00796b" }} />
                    ) : null
                  }
                  sx={{
                    borderColor: "#00796b",
                    color: "#00796b",
                    fontSize: "0.72rem",
                    whiteSpace: "nowrap",
                    "&:hover": { bgcolor: "rgba(0,121,107,0.08)" },
                  }}
                >
                  {summaryRefreshLoading ? "Refreshing…" : "Refresh Summaries"}
                </Button>
              </span>
            </MuiTooltip>
          )}
          {isSuperRiskAdmin && (
            <MuiTooltip title="Retroactively classify existing alerts (reliability tier, event tag, consequence level). Processes 200 at a time — run multiple times until counts reach 0.">
              <span>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={classifyBackfillLoading}
                  onClick={() => handleClassifyBackfill(["reliability", "eventTag", "consequence"])}
                  startIcon={
                    classifyBackfillLoading ? (
                      <CircularProgress size={14} sx={{ color: "#7b1fa2" }} />
                    ) : null
                  }
                  sx={{
                    borderColor: "#7b1fa2",
                    color: "#7b1fa2",
                    fontSize: "0.72rem",
                    whiteSpace: "nowrap",
                    "&:hover": { bgcolor: "rgba(123,31,162,0.08)" },
                  }}
                >
                  {classifyBackfillLoading ? "Classifying…" : "Backfill Classifications"}
                </Button>
              </span>
            </MuiTooltip>
          )}
          {isSuperRiskAdmin && (
            <MuiTooltip title="Re-run the theme categorisation over historical alerts using the new classifier. Processes 1000 at a time — run repeatedly until 'remaining' reaches 0, then click Rebuild Themes. Use Reset Pass to start fresh.">
              <span>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={recatLoading}
                  onClick={() => handleRecategorize({ batchSize: 1000 })}
                  startIcon={
                    recatLoading ? <CircularProgress size={14} sx={{ color: "#0277bd" }} /> : null
                  }
                  sx={{
                    borderColor: "#0277bd",
                    color: "#0277bd",
                    fontSize: "0.72rem",
                    whiteSpace: "nowrap",
                    "&:hover": { bgcolor: "rgba(2,119,189,0.08)" },
                  }}
                >
                  {recatLoading ? "Working…" : "Re-categorise Alerts"}
                </Button>
              </span>
            </MuiTooltip>
          )}
          {isSuperRiskAdmin && (
            <MuiTooltip title="Start a fresh recategorisation pass: clears the 'done' marker on all alerts so Re-categorise Alerts reprocesses everything.">
              <span>
                <Button
                  size="small"
                  variant="text"
                  disabled={recatLoading}
                  onClick={() => handleRecategorize({ reset: true })}
                  sx={{ color: "#0277bd", fontSize: "0.72rem", whiteSpace: "nowrap" }}
                >
                  Reset Pass
                </Button>
              </span>
            </MuiTooltip>
          )}
          {isSuperRiskAdmin && (
            <MuiTooltip title="ID124 — re-assign each alert's risk category to a single L1 › L2 over historical alerts (fixes themes stuck on an L1 only). Processes 1000 at a time — run until 'remaining' reaches 0; themes refresh automatically when done.">
              <span>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={recatLoading}
                  onClick={() => handleRecategorizeCategories({ batchSize: 1000 })}
                  startIcon={
                    recatLoading ? <CircularProgress size={14} sx={{ color: "#00695c" }} /> : null
                  }
                  sx={{
                    borderColor: "#00695c",
                    color: "#00695c",
                    fontSize: "0.72rem",
                    whiteSpace: "nowrap",
                    "&:hover": { bgcolor: "rgba(0,105,92,0.08)" },
                  }}
                >
                  {recatLoading ? "Working…" : "Re-categorise Categories"}
                </Button>
              </span>
            </MuiTooltip>
          )}
          {isSuperRiskAdmin && (
            <MuiTooltip title="AI merges duplicate/synonym theme labels (e.g. 'Jet Fuel Prices' + 'Oil Prices' → 'Fuel Costs') and remaps their alerts. Run 'Rebuild Themes' afterwards to refresh the list.">
              <span>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={recatLoading}
                  onClick={handleConsolidateThemes}
                  startIcon={
                    recatLoading ? <CircularProgress size={14} sx={{ color: "#00695c" }} /> : null
                  }
                  sx={{
                    borderColor: "#00695c",
                    color: "#00695c",
                    fontSize: "0.72rem",
                    whiteSpace: "nowrap",
                    "&:hover": { bgcolor: "rgba(0,105,92,0.08)" },
                  }}
                >
                  {recatLoading ? "Working…" : "Consolidate Themes"}
                </Button>
              </span>
            </MuiTooltip>
          )}
          {isSuperRiskAdmin && (
            <MuiTooltip title="AI clubs over-split event tags for the SAME real-world incident (e.g. the many Sydney near-miss / near-collision / runway slugs) into one event card, across all themes. Runs in the background (takes a few minutes) — reload to see merged cards. Guards prevent over-merging across incidents/classes. Also runs automatically each night.">
              <span>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={eventConsolLoading}
                  onClick={handleConsolidateEvents}
                  startIcon={
                    eventConsolLoading ? (
                      <CircularProgress size={14} sx={{ color: "#00695c" }} />
                    ) : null
                  }
                  sx={{
                    borderColor: "#00695c",
                    color: "#00695c",
                    fontSize: "0.72rem",
                    whiteSpace: "nowrap",
                    "&:hover": { bgcolor: "rgba(0,105,92,0.08)" },
                  }}
                >
                  {eventConsolLoading ? "Working…" : "Consolidate Events"}
                </Button>
              </span>
            </MuiTooltip>
          )}
          {isSuperRiskAdmin && (
            <MuiTooltip title="V2: regenerate the top-down (CRO) emerging themes across MULTIPLE lenses — Global + each configured geography + each sector + the organisation — tagging each theme with its origin lens. Runs in the background (~1 LLM call per lens, a few minutes) — reload to see them.">
              <span>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={topDownLoading}
                  onClick={handleTopDownMultiLens}
                  startIcon={
                    topDownLoading ? <CircularProgress size={14} sx={{ color: "#5e35b1" }} /> : null
                  }
                  sx={{
                    borderColor: "#5e35b1",
                    color: "#5e35b1",
                    fontSize: "0.72rem",
                    whiteSpace: "nowrap",
                    "&:hover": { bgcolor: "rgba(94,53,177,0.08)" },
                  }}
                >
                  {topDownLoading ? "Working…" : "Top-Down (Multi-lens)"}
                </Button>
              </span>
            </MuiTooltip>
          )}
          {isSuperRiskAdmin && (
            <MuiTooltip title="Delete ALL themes and recreate them: rebuild bottom-up themes from the current news alerts (alerts kept), then regenerate the top-down (CRO) emerging risks and merge them in. Summaries/ratings regenerate in the background.">
              <span>
                <Button
                  size="small"
                  variant="contained"
                  disabled={recatLoading}
                  onClick={handleRebuildAll}
                  startIcon={
                    recatLoading ? <CircularProgress size={14} sx={{ color: "#fff" }} /> : null
                  }
                  sx={{
                    bgcolor: "#c62828",
                    color: "#fff",
                    fontSize: "0.72rem",
                    whiteSpace: "nowrap",
                    "&:hover": { bgcolor: "#a31515" },
                  }}
                >
                  {recatLoading ? "Working…" : "Rebuild All Themes (News + Top-Down)"}
                </Button>
              </span>
            </MuiTooltip>
          )}
        </Box>

        {themeOverview.isOwnerFiltered && (
          <Alert severity="info" sx={{ mb: 2, fontSize: "0.82rem" }}>
            Showing themes scoped to your assigned categories
            {themeOverview.ownerCategoryIds?.length === 0
              ? " — no categories assigned yet. Contact your administrator."
              : "."}
          </Alert>
        )}

        <Box sx={{ mb: 1.5 }}>
          <ChangeToggle
            on={showThemeChange}
            onClick={() => setShowThemeChange((s) => !s)}
            summary={themeChangeSummary}
          />
        </Box>

        <HorizonThemeOverviewRows
          themes={filteredThemes}
          loading={overviewLoading}
          error={overviewError}
          adminView={adminView}
          onSelectTheme={(key) => setSelectedThemeKey(key)}
          themeCategories={themeCategories}
          selectedThemes={new Set(monitorSelection.keys())}
          onToggleTheme={handleToggleMonitor}
          isHistorical={false}
          canMonitor={canMonitor}
          linkedThemeKeySet={linkedThemeKeySet}
          linkedRiskFor={linkedRiskFor}
          onOpenWatchlistRisk={openWatchlistRisk}
          sortOrder={sortOrder}
          onSortChange={setSortOrder}
          showChange={showThemeChange}
          changeFor={themeChangeFor}
        />

        {/* Floating action bar — appears when themes are selected (non-VIEW roles only) */}
        {canMonitor && monitorSelection.size > 0 ? (
          <Paper
            elevation={6}
            sx={{
              position: "fixed",
              bottom: 24,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1300,
              px: 3,
              py: 1.5,
              display: "flex",
              alignItems: "center",
              gap: 2,
              borderRadius: 3,
              bgcolor: "rgba(213, 179, 240, 0.92)",
              color: "white",
              backdropFilter: "blur(6px)",
              minWidth: 340,
            }}
          >
            <MDTypography variant="body2" sx={{ color: "white", flex: 1 }}>
              {monitorSelection.size} theme{monitorSelection.size > 1 ? "s" : ""} selected
            </MDTypography>
            <Button
              variant="outlined"
              size="small"
              onClick={() => setMonitorSelection(new Map())}
              sx={{ borderColor: "rgba(255,255,255,0.5)", color: "white", whiteSpace: "nowrap" }}
            >
              Clear
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={handleSaveAsEmergingRisk}
              sx={{
                bgcolor: "#52009b",
                color: "white",
                whiteSpace: "nowrap",
                "&:hover": { bgcolor: "#3a006b" },
              }}
            >
              Save &amp; Monitor
            </Button>
          </Paper>
        ) : null}
      </>
    );
  } else {
    // Theme drill-down: flat alert list
    // selectedThemeObj is now defined at component level (useMemo above)
    // Prefer the theme's actual name (LLM display name / label) over the raw key (which is the category).
    const themeLabel =
      selectedThemeKey === "__uncategorized__"
        ? "Uncategorized"
        : selectedThemeObj?.llmTrend?.displayName ||
          selectedThemeObj?.themeLabel ||
          selectedThemeKey;

    // Build per-theme trend chart data
    const themeTrendSeries = themeTrend?.themes?.[0]?.series || [];
    const themeTrendChartData = themeTrendSeries.map((p) => ({ day: p.day, count: p.count }));
    const formatTrendDay = (d) => (!d || d.length < 10 ? d : `${d.slice(8, 10)}/${d.slice(5, 7)}`);

    // Risk level trend (Chart 1, ID54) — granular prioritisation-matrix number (e.g. 1..11).
    const riskLevelSeries = themeTrendSeries
      .filter((p) => p.matrixRatingNum != null)
      .map((p) => ({
        day: p.day,
        riskLevel: p.matrixRatingNum,
        letter: p.matrixRating || "",
        exact: p.matrixRatingNumExact !== false,
      }));
    const hasRiskLevelData = riskLevelSeries.length > 0;
    // Y-axis scales to the data (granular numbers can exceed the 1..5 letter range).
    const riskLevelMax = Math.max(11, ...riskLevelSeries.map((p) => p.riskLevel || 0));
    // Letter-band reference ticks placed at representative numbers.
    const RISK_BAND_TICKS = { 1: "VL", 3: "L", 5: "M", 8: "H", 10: "E" };

    // ID61 — derive trend direction from risk level data instead of LLM guess
    const dataBasedTrend = (() => {
      if (riskLevelSeries.length < 4) return null;
      const half = Math.floor(riskLevelSeries.length / 2);
      const recent = riskLevelSeries.slice(-half);
      const prior = riskLevelSeries.slice(0, half);
      const avgRecent = recent.reduce((s, p) => s + p.riskLevel, 0) / recent.length;
      const avgPrior = prior.reduce((s, p) => s + p.riskLevel, 0) / prior.length;
      const delta = avgRecent - avgPrior;
      if (delta > 0.8) return "worsening";
      if (delta < -0.8) return "improving";
      return "stable";
    })();

    // Build consequence-level stacked trend from loaded articles
    const CONSEQUENCE_LEVEL_COLORS = {
      "Level 1": "#90a4ae",
      "Level 2": "#c8e6c9",
      "Level 3": "#388e3c",
      "Level 4": "#fdd835",
      "Level 5": "#ef6c00",
      "Level 6": "#c62828",
      Unclassified: "#e0e0e0",
    };
    const LEVEL_ORDER = [
      "Level 1",
      "Level 2",
      "Level 3",
      "Level 4",
      "Level 5",
      "Level 6",
      "Unclassified",
    ];

    const byDay = {};
    const sentimentByDay = {}; // { day: { sum, count } }
    filteredDetailRaw.forEach((a) => {
      const day = a.ingestedAt ? new Date(a.ingestedAt).toISOString().slice(0, 10) : null;
      if (!day) return;
      if (!byDay[day]) byDay[day] = {};
      const level = a.consequenceLevelLabel || "Unclassified";
      byDay[day][level] = (byDay[day][level] || 0) + 1;
      // Sentiment: positive=1, neutral=0, negative=-1
      const sentVal = a.sentiment === "positive" ? 1 : a.sentiment === "negative" ? -1 : 0;
      if (!sentimentByDay[day]) sentimentByDay[day] = { sum: 0, count: 0 };
      sentimentByDay[day].sum += sentVal;
      sentimentByDay[day].count += 1;
    });

    const consequenceTrendData = themeTrendChartData.map(({ day, count }) => {
      const row = { day, ...(byDay[day] || {}) };
      const classified = Object.entries(row)
        .filter(([k]) => k !== "day")
        .reduce((s, [, v]) => s + v, 0);
      if (count > classified) {
        row.Unclassified = (row.Unclassified || 0) + (count - classified);
      }
      // Add sentiment average (null when no data that day)
      const sd = sentimentByDay[day];
      row.sentimentAvg = sd && sd.count > 0 ? Math.round((sd.sum / sd.count) * 100) / 100 : null;
      return row;
    });

    const activeLevelKeys = LEVEL_ORDER.filter((k) =>
      consequenceTrendData.some((d) => (d[k] || 0) > 0)
    );
    const hasSentimentData = consequenceTrendData.some((d) => d.sentimentAvg !== null);

    detailTabBody = (
      <>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2, flexWrap: "wrap" }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => setSelectedThemeKey(null)}
            sx={{ borderColor: "#52009b", color: "#52009b" }}
          >
            ← All Emerging Themes
          </Button>
          <MDTypography variant="subtitle1" fontWeight="bold" color="text">
            {themeLabel}
          </MDTypography>
          <MDTypography variant="body2" color="text">
            {dateFilteredDetailRaw.length} alert{dateFilteredDetailRaw.length === 1 ? "" : "s"}
          </MDTypography>
          {/* ID124 — risk category (L1 › L2) on the theme detail page */}
          {(() => {
            const cats = themeCategories ? themeCategories[selectedThemeKey] : null;
            const bestL2 = selectedThemeObj?.bestFitL2 || cats?.bestFitL2;
            let path = "";
            if (cats && cats.l1Names.length) {
              const l1 = cats.l1Names[0];
              const l2 = bestL2 || (cats.l2ByL1[l1] || [])[0];
              path = l2 ? `${l1} › ${l2}` : l1;
            } else if (bestL2) {
              path = bestL2;
            }
            return path ? (
              <Chip
                label={path}
                size="small"
                sx={{ bgcolor: "#e3f2fd", color: "#1565c0", fontWeight: 600 }}
              />
            ) : null;
          })()}
          {selectedTrendDate && (
            <Chip
              label={`Showing ${formatTrendDay(selectedTrendDate)}`}
              size="small"
              onDelete={() => setSelectedTrendDate(null)}
              sx={{ bgcolor: "rgba(82,0,155,0.1)", color: "#52009b", fontWeight: 600 }}
            />
          )}
          {/* ID169 — advance THIS theme to the watchlist straight from the details page. Hidden
              once the theme is already linked to a watchlist risk (the ⚑ link shows instead). */}
          {canMonitor && selectedThemeObj && !(linkedRiskFor && linkedRiskFor(selectedThemeObj)) && (
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleSaveAsEmergingRisk([selectedThemeObj])}
              sx={{
                ml: "auto",
                borderColor: "#52009b",
                color: "#52009b",
                whiteSpace: "nowrap",
                "&:hover": { borderColor: "#3a006b", bgcolor: "rgba(82,0,155,0.06)" },
              }}
            >
              Advance to Watchlist
            </Button>
          )}
        </Box>

        {/* Sentiment + Why it matters — shown before the articles */}
        {selectedThemeObj && (
          <Card variant="outlined" sx={{ mb: 2.5, borderColor: "rgba(82,0,155,0.2)" }}>
            <CardContent sx={{ pb: "12px !important" }}>
              {/* Sentiment row */}
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  flexWrap: "wrap",
                  alignItems: "center",
                  mb: selectedThemeObj.summary ? 1.5 : 0,
                }}
              >
                {/* ID154 — link to the watchlist risk this theme is linked to, with its name. */}
                {(() => {
                  const lr = linkedRiskFor ? linkedRiskFor(selectedThemeObj) : null;
                  if (!lr) return null;
                  return (
                    <MuiTooltip title={`Open watchlist risk: ${lr.title}`} placement="top">
                      <Box
                        onClick={() => lr.id && openWatchlistRisk(lr.id)}
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 0.5,
                          px: "8px",
                          py: "3px",
                          borderRadius: "4px",
                          fontSize: "0.72rem",
                          fontWeight: 700,
                          bgcolor: "#ede7f6",
                          color: "#52009b",
                          border: "1px solid #ce93d8",
                          cursor: lr.id ? "pointer" : "default",
                          maxWidth: 320,
                          "&:hover": lr.id ? { bgcolor: "#e1d4f5" } : undefined,
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          ⚑ Watchlist Risk: {lr.title}
                        </Box>
                      </Box>
                    </MuiTooltip>
                  );
                })()}
                {/* ID60 — overall risk level for the theme, surfaced at the top of this box.
                    ID123 — same "why it's rated" breakdown as the themes list tooltip. */}
                {selectedThemeObj.llmTrend?.matrixRating && (
                  <MuiTooltip
                    title={[
                      `Risk level: ${selectedThemeObj.llmTrend.matrixRating}${
                        selectedThemeObj.llmTrend.matrixRating === "E"
                          ? " — Extreme"
                          : selectedThemeObj.llmTrend.matrixRating === "H"
                          ? " — High"
                          : selectedThemeObj.llmTrend.matrixRating === "M"
                          ? " — Medium"
                          : selectedThemeObj.llmTrend.matrixRating === "L"
                          ? " — Low"
                          : " — Very Low"
                      }`,
                      selectedThemeObj.llmTrend.consequenceTypeLabel
                        ? `Consequence type: ${selectedThemeObj.llmTrend.consequenceTypeLabel}`
                        : "",
                      selectedThemeObj.llmTrend.consequenceLevelLabel
                        ? `Consequence level: ${selectedThemeObj.llmTrend.consequenceLevelLabel}`
                        : "",
                      selectedThemeObj.llmTrend.plausibilityRating
                        ? `Plausibility: ${selectedThemeObj.llmTrend.plausibilityRating}`
                        : "",
                    ]
                      .filter(Boolean)
                      .join(" · ")}
                    placement="top"
                  >
                    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
                      <MDTypography variant="caption" sx={{ fontWeight: 700, color: "#374151" }}>
                        Risk level
                      </MDTypography>
                      <RatingBadge rating={selectedThemeObj.llmTrend.matrixRating} size="large" />
                    </Box>
                  </MuiTooltip>
                )}
                {selectedThemeObj.llmTrend && (
                  <MuiTooltip
                    title={
                      dataBasedTrend
                        ? `Trend derived from ${themeTrendDays}-day risk level history${
                            selectedThemeObj.llmTrend.narrative
                              ? ` · ${selectedThemeObj.llmTrend.narrative}`
                              : ""
                          }`
                        : selectedThemeObj.llmTrend.narrative
                        ? `${selectedThemeObj.llmTrend.narrative} (confidence: ${
                            selectedThemeObj.llmTrend.confidence || "?"
                          })`
                        : `LLM assessment: ${selectedThemeObj.llmTrend.direction}`
                    }
                    placement="top"
                  >
                    {(() => {
                      const dir = dataBasedTrend || selectedThemeObj.llmTrend.direction;
                      return (
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            px: "10px",
                            py: "4px",
                            borderRadius: "6px",
                            fontSize: "0.75rem",
                            fontWeight: 700,
                            color:
                              dir === "worsening"
                                ? "#b71c1c"
                                : dir === "improving"
                                ? "#1b5e20"
                                : "#37474f",
                            bgcolor:
                              dir === "worsening"
                                ? "#ffebee"
                                : dir === "improving"
                                ? "#e8f5e9"
                                : "#eceff1",
                            border: "1px solid",
                            borderColor:
                              dir === "worsening"
                                ? "#ef9a9a"
                                : dir === "improving"
                                ? "#a5d6a7"
                                : "#b0bec5",
                            cursor: "default",
                          }}
                        >
                          {dir === "worsening"
                            ? "⚠ Worsening"
                            : dir === "improving"
                            ? "✓ Improving"
                            : "~ Stable"}
                        </Box>
                      );
                    })()}
                  </MuiTooltip>
                )}
                {selectedThemeObj.trend7d && selectedThemeObj.trend7d.direction !== "stable" && (
                  <MuiTooltip
                    title={`7-day news stream: ${selectedThemeObj.trend7d.recent7} (prev ${
                      selectedThemeObj.trend7d.prior7
                    }) — ${selectedThemeObj.trend7d.pct > 0 ? "+" : ""}${
                      selectedThemeObj.trend7d.pct
                    }%`}
                    placement="top"
                  >
                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        px: "10px",
                        py: "4px",
                        borderRadius: "6px",
                        fontSize: "0.75rem",
                        fontWeight: 700,
                        color:
                          selectedThemeObj.trend7d.direction === "increasing"
                            ? "#b71c1c"
                            : "#1b5e20",
                        bgcolor:
                          selectedThemeObj.trend7d.direction === "increasing"
                            ? "#ffebee"
                            : "#e8f5e9",
                        border: "1px solid",
                        borderColor:
                          selectedThemeObj.trend7d.direction === "increasing"
                            ? "#ef9a9a"
                            : "#a5d6a7",
                        cursor: "default",
                      }}
                    >
                      {selectedThemeObj.trend7d.direction === "increasing" ? "↑" : "↓"} 7-day news
                      stream {selectedThemeObj.trend7d.pct > 0 ? "+" : ""}
                      {selectedThemeObj.trend7d.pct}%
                    </Box>
                  </MuiTooltip>
                )}
                <MuiTooltip title="Today's news stream count for this theme" placement="top">
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      px: "10px",
                      py: "4px",
                      borderRadius: "6px",
                      fontSize: "0.75rem",
                      fontWeight: 700,
                      color: "#4a148c",
                      bgcolor: "#f3e5f5",
                      border: "1px solid #ce93d8",
                    }}
                  >
                    Today&apos;s news stream: {selectedThemeObj.countToday || 0}
                  </Box>
                </MuiTooltip>
              </Box>

              {/* What's happening (factual summary) */}
              {selectedThemeObj.summary && (
                <Box sx={{ mb: selectedThemeObj.whyItMatters ? 1.5 : 0 }}>
                  <MDTypography
                    variant="subtitle2"
                    fontWeight="bold"
                    sx={{ mb: 0.5, color: "#374151" }}
                  >
                    What&apos;s happening
                  </MDTypography>
                  <MDTypography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    {selectedThemeObj.summary}
                  </MDTypography>
                </Box>
              )}
              {/* Why it matters (risk relevance) */}
              {selectedThemeObj.whyItMatters && (
                <Box>
                  <MDTypography
                    variant="subtitle2"
                    fontWeight="bold"
                    sx={{ mb: 0.5, color: "#52009b" }}
                  >
                    Why it matters
                  </MDTypography>
                  <MDTypography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    {selectedThemeObj.whyItMatters}
                  </MDTypography>
                </Box>
              )}
              {/* Fallback when no LLM summary is available yet */}
              {!selectedThemeObj.summary && !selectedThemeObj.whyItMatters && (
                <MDTypography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                  Summary will appear after the next ingest run.
                </MDTypography>
              )}
            </CardContent>
          </Card>
        )}

        {/* Chart 1 — Risk level trend line (ID54) */}
        <Card variant="outlined" sx={{ mb: 2.5, borderColor: "rgba(82,0,155,0.2)" }}>
          <CardContent sx={{ pb: "12px !important" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1, flexWrap: "wrap" }}>
              <MDTypography variant="subtitle2" fontWeight="bold">
                Risk level trend
              </MDTypography>
              {dataBasedTrend && (
                <Box
                  sx={{
                    px: "7px",
                    py: "1px",
                    borderRadius: "4px",
                    fontSize: "0.68rem",
                    fontWeight: 700,
                    bgcolor:
                      dataBasedTrend === "worsening"
                        ? "#ffebee"
                        : dataBasedTrend === "improving"
                        ? "#e8f5e9"
                        : "#eceff1",
                    color:
                      dataBasedTrend === "worsening"
                        ? "#b71c1c"
                        : dataBasedTrend === "improving"
                        ? "#1b5e20"
                        : "#37474f",
                    border: "1px solid",
                    borderColor:
                      dataBasedTrend === "worsening"
                        ? "#ef9a9a"
                        : dataBasedTrend === "improving"
                        ? "#a5d6a7"
                        : "#b0bec5",
                  }}
                >
                  {dataBasedTrend === "worsening"
                    ? "⚠ Worsening"
                    : dataBasedTrend === "improving"
                    ? "✓ Improving"
                    : "~ Stable"}
                </Box>
              )}
              <Box sx={{ ml: "auto", display: "flex", gap: 0.5 }}>
                {[7, 30, 90, 365].map((d) => (
                  <Box
                    key={d}
                    onClick={() => setThemeTrendDays(d)}
                    sx={{
                      px: "7px",
                      py: "1px",
                      borderRadius: "4px",
                      fontSize: "0.68rem",
                      fontWeight: 600,
                      cursor: "pointer",
                      border: "1px solid",
                      bgcolor: themeTrendDays === d ? "#52009b" : "transparent",
                      color: themeTrendDays === d ? "#fff" : "#52009b",
                      borderColor: "#52009b",
                    }}
                  >
                    {d}d
                  </Box>
                ))}
              </Box>
            </Box>
            {themeTrendLoading && (
              <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                <CircularProgress size={24} sx={{ color: "#52009b" }} />
              </Box>
            )}
            {!themeTrendLoading && !hasRiskLevelData && (
              <MDTypography variant="body2" color="text.secondary">
                Risk level history builds as the LLM rates this theme each day. Check back after the
                next ingest run.
              </MDTypography>
            )}
            {!themeTrendLoading && hasRiskLevelData && (
              <Box sx={{ width: "100%", height: 200 }}>
                <ResponsiveContainer>
                  <LineChart
                    data={riskLevelSeries}
                    margin={{ top: 4, right: 16, left: 0, bottom: 28 }}
                    onClick={(e) => {
                      if (e && e.activeLabel) setSelectedTrendDate(e.activeLabel);
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.07)" />
                    <XAxis
                      dataKey="day"
                      tickFormatter={formatTrendDay}
                      angle={-45}
                      textAnchor="end"
                      tick={{ fontSize: 11 }}
                      interval={Math.max(0, Math.floor(riskLevelSeries.length / 10) - 1)}
                    />
                    <YAxis
                      tick={{ fontSize: 10 }}
                      domain={[0.5, riskLevelMax + 0.5]}
                      ticks={Object.keys(RISK_BAND_TICKS).map(Number)}
                      tickFormatter={(v) => RISK_BAND_TICKS[v] || ""}
                      width={28}
                    />
                    <Tooltip
                      labelFormatter={(label) => `Day: ${label} — click to see news stream`}
                      formatter={(v, name, item) => {
                        const lt = item?.payload?.letter;
                        return [lt ? `${v} (${lt})` : v, name];
                      }}
                    />
                    <Line
                      type="monotone"
                      dataKey="riskLevel"
                      name="Risk level"
                      stroke="#52009b"
                      strokeWidth={2.5}
                      dot={<RiskLevelDot />}
                      activeDot={{ r: 6 }}
                      connectNulls={false}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </Box>
            )}
          </CardContent>
        </Card>

        {/* Consequence level trend */}
        <Card variant="outlined" sx={{ mb: 2.5, borderColor: "rgba(82,0,155,0.2)" }}>
          <CardContent sx={{ pb: "12px !important" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1, flexWrap: "wrap" }}>
              <MDTypography variant="subtitle2" fontWeight="bold">
                30-day volume by consequence level
              </MDTypography>
              {selectedThemeObj?.llmTrend?.matrixRating ? (
                <MuiTooltip
                  title={[
                    `Prioritisation rating: ${selectedThemeObj.llmTrend.matrixRating}`,
                    selectedThemeObj.llmTrend.consequenceLevelLabel
                      ? ` · ${selectedThemeObj.llmTrend.consequenceLevelLabel}`
                      : "",
                    selectedThemeObj.llmTrend.consequenceTypeLabel
                      ? ` · ${selectedThemeObj.llmTrend.consequenceTypeLabel}`
                      : "",
                    selectedThemeObj.llmTrend.plausibilityRating
                      ? ` · ${selectedThemeObj.llmTrend.plausibilityRating}`
                      : "",
                  ].join("")}
                  placement="top"
                >
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      px: "10px",
                      py: "3px",
                      borderRadius: "6px",
                      fontSize: "0.8rem",
                      fontWeight: 800,
                      letterSpacing: "0.05em",
                      bgcolor: selectedThemeObj.llmTrend.matrixRatingColor || "#90a4ae",
                      color: ["VL", "M"].includes(selectedThemeObj.llmTrend.matrixRating)
                        ? "#212121"
                        : "#fff",
                      cursor: "default",
                    }}
                  >
                    {selectedThemeObj.llmTrend.matrixRating}
                  </Box>
                </MuiTooltip>
              ) : null}
            </Box>
            {themeTrendLoading && (
              <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                <CircularProgress size={24} sx={{ color: "#52009b" }} />
              </Box>
            )}
            {!themeTrendLoading && consequenceTrendData.length === 0 && (
              <MDTypography variant="body2" color="text">
                No trend data available yet.
              </MDTypography>
            )}
            {!themeTrendLoading && consequenceTrendData.length > 0 && (
              <Box sx={{ width: "100%", height: 220 }}>
                <ResponsiveContainer>
                  <ComposedChart
                    data={consequenceTrendData}
                    margin={{ top: 4, right: hasSentimentData ? 40 : 16, left: 0, bottom: 28 }}
                    onClick={(e) => {
                      if (e && e.activeLabel) setSelectedTrendDate(e.activeLabel);
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.07)" />
                    <XAxis
                      dataKey="day"
                      tickFormatter={formatTrendDay}
                      angle={-45}
                      textAnchor="end"
                      tick={{ fontSize: 11 }}
                      interval={Math.max(0, Math.floor(consequenceTrendData.length / 10) - 1)}
                    />
                    <YAxis
                      yAxisId="left"
                      tick={{ fontSize: 11 }}
                      allowDecimals={false}
                      width={28}
                    />
                    {hasSentimentData && (
                      <YAxis
                        yAxisId="right"
                        orientation="right"
                        domain={[-1, 1]}
                        tick={{ fontSize: 10 }}
                        width={36}
                        tickFormatter={(v) => (v === 1 ? "😊" : v === -1 ? "😟" : "😐")}
                      />
                    )}
                    <Tooltip
                      labelFormatter={(label) => `Day: ${label}`}
                      formatter={(v, name) => {
                        if (name === "Sentiment") {
                          const label = v > 0.2 ? "Positive" : v < -0.2 ? "Negative" : "Neutral";
                          return [`${v > 0 ? "+" : ""}${v.toFixed(2)} (${label})`, name];
                        }
                        return [v, name];
                      }}
                    />
                    <Legend wrapperStyle={{ fontSize: 11, paddingTop: 8 }} />
                    {activeLevelKeys.map((k) => (
                      <Bar
                        key={k}
                        yAxisId="left"
                        dataKey={k}
                        stackId="level"
                        fill={CONSEQUENCE_LEVEL_COLORS[k]}
                        stroke={k === "Unclassified" ? "#bdbdbd" : undefined}
                        strokeWidth={k === "Unclassified" ? 0.5 : 0}
                      />
                    ))}
                    {hasSentimentData && (
                      <Line
                        yAxisId="right"
                        type="monotone"
                        dataKey="sentimentAvg"
                        name="Sentiment"
                        stroke="#7b1fa2"
                        strokeWidth={2}
                        dot={false}
                        activeDot={{ r: 4 }}
                        connectNulls
                      />
                    )}
                  </ComposedChart>
                </ResponsiveContainer>
              </Box>
            )}
          </CardContent>
        </Card>

        {/* News Stream header + sort control (ID149 — default by date, switchable to risk level).
            Render it whenever there are articles OR some are hidden by the relevance filter, so the
            "Show all (N hidden)" escape hatch is always reachable — otherwise a theme whose only
            articles are low-relevance shows a dead-end "No news stream". */}
        {(detailTableRows.length > 0 || hiddenLowRelevanceCount > 0) && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              mb: 1,
              flexWrap: "wrap",
            }}
          >
            <MDTypography variant="subtitle2" fontWeight="bold" sx={{ color: "#374151" }}>
              News Stream
            </MDTypography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
              {hiddenLowRelevanceCount > 0 || !hideLowRelevance ? (
                <MuiTooltip
                  title="Low-relevance alerts (off your geography/industry) are hidden by default so the material items surface."
                  placement="top"
                >
                  <span>
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{
                        color: "#52009b",
                        borderColor: "#52009b",
                        textTransform: "none",
                        fontSize: 11,
                        py: 0.25,
                      }}
                      onClick={() => setHideLowRelevance((v) => !v)}
                    >
                      {hideLowRelevance
                        ? `Show all (${hiddenLowRelevanceCount} hidden)`
                        : "Hide off-target"}
                    </Button>
                  </span>
                </MuiTooltip>
              ) : null}
              <FormControl size="small" sx={{ minWidth: 170 }}>
                <InputLabel id="news-sort-label">Sort by</InputLabel>
                <Select
                  labelId="news-sort-label"
                  label="Sort by"
                  value={newsSort}
                  onChange={(e) => setNewsSort(e.target.value)}
                >
                  <MenuItem value="date">Date (newest first)</MenuItem>
                  <MenuItem value="risk">Risk level (highest first)</MenuItem>
                  <MenuItem value="relevance">Relevance (highest first)</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
        )}

        {detailTableRows.length > 0 ? (
          <INDataTable
            disableCard
            columns={detailColumns}
            data={detailTableRows}
            initialState={{ density: "spacious" }}
          />
        ) : hiddenLowRelevanceCount > 0 ? (
          <MDTypography variant="body2" color="text">
            {hiddenLowRelevanceCount} low-relevance alert
            {hiddenLowRelevanceCount > 1 ? "s are" : " is"} hidden — use “Show all” above to view
            {hiddenLowRelevanceCount > 1 ? " them" : " it"}.
          </MDTypography>
        ) : (
          <MDTypography variant="body2" color="text">
            No news stream for this theme.
          </MDTypography>
        )}
      </>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container style={{ borderRadius: "5px", padding: "15px" }} spacing={2}>
        <Grid item md={12}>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={mainTab}
                onChange={(_, v) => setMainTab(v)}
                aria-label="Horizon main tabs"
              >
                <Tab label="Emerging Themes Dashboard" {...a11yProps(0)} />
                <Tab label="Emerging Themes List" {...a11yProps(1)} />
                <Tab label="Emerging Themes Search Parameters" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={mainTab} index={0}>
              {modules?.horizonV2 ? (
                <AnticipateHorizonScanV2 />
              ) : (
                <HorizonScatterDashboard
                  themes={dashThemes}
                  todayUtc={themeOverview?.todayUtc}
                  activeRisks={dashRisks}
                  loading={dashLoading}
                  error={dashError}
                  onRefresh={fetchHorizonDashboard}
                  evalCriteria={dashEvalCriteria}
                  onOpenWatchlistRisk={openWatchlistRisk}
                  onOpenThemeDetail={openThemeDetail}
                />
              )}
            </CustomTabPanel>
            <CustomTabPanel value={mainTab} index={1}>
              {modules?.horizonV2 ? <AnticipateEmergingThemesV2 /> : detailTabBody}
            </CustomTabPanel>
            <CustomTabPanel value={mainTab} index={2}>
              <SearchParametersPanel
                execute={execute}
                selectedIds={displayFilterIds}
                onChangeSelected={setDisplayFilterIds}
              />
            </CustomTabPanel>
          </Box>
        </Grid>
      </Grid>
      <Snackbar
        open={!!ignoreSnack}
        autoHideDuration={5000}
        onClose={() => setIgnoreSnack(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setIgnoreSnack(null)}
          severity={ignoreSnack?.severity || "success"}
          sx={{ width: "100%" }}
        >
          {ignoreSnack?.message}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default AnticipateHorizonScan;
